import { compileStatistics } from "../helpers/compileStatistics";
import TeamLeagueWorkspace from "./TeamLeagueWorkspace";
import {canUseTeamWorkspace} from "../helpers/teamWorkspace";
import TeamAnalysisDialog from './LegacyTeamAnalysisDialog';
import { DayStatisticsEntry } from "./DayStatistics";
import { storedModelOdd } from "../helpers/leagueStoredModels";
import { GamesRangeControls } from "./GamesRangeControls";
import { initialFixtureDay, today, weekSection, dateKey, addDays, fixtureInRange, sortGames } from "../helpers/gamesPeriod";
import { automaticDaySelection, weekCompilationSelection, selectableDayFixture, fixtureKickoff, finishedFixture } from "../helpers/dayFixtureWorkflow";
import { readWorkflowResponse, compileBatchOutcome } from "../helpers/workflowResponse";
import { compareLeagueSelection, getLeagueCountryName } from "../helpers/leagueSelection";
import { fixtureProcessingStatus } from "../helpers/fixtureProcessingStatus";
import { ThemeProvider } from "@mui/material/styles";
import { workareaTheme } from "../helpers/workareaTheme";
import { evaluationFailureText } from "../helpers/evaluationFailure";
import { mergeLeagueFixtureTruth } from "../helpers/adminLeague";
import { getGermanFixtureDate } from "../helpers/fixtureDate";
import { AdminLeagueWorkspace } from "./AdminLeagueWorkspace";
import { LeagueMatchdayEntry } from "./LeagueMatchdayEntry";
import i18next from "i18next";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Tooltip,
  Backdrop,
  Checkbox,
  CircularProgress,
  Container,
  LinearProgress,
  Paper,
  Popover,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { fetchFromApi } from "../helpers/fetchFromApi";
import { fetchViaPost } from "../helpers/fetchViaPost";
import { DataGridPro, GRID_CHECKBOX_SELECTION_COL_DEF } from "@mui/x-data-grid-pro";
import { STATI } from "../helpers/stati";
import { canEvaluate } from "../helpers/canEvaluate";
import { canCompile } from "../helpers/canCompile";
import {
  isFixtureEvaluationFinalized,
  isNormalCompileCandidate,
} from "../helpers/fixtureFinalization";
import { FixturesFooter } from "./FixturesFooter";
import {
  CompilePreviewDialog,
  buildFixtureDetailRefreshRequests,
  draftFixtureDetail,
  mergeCompiledFixtureDetails,
  rankTeamSettings,
  restoreFixtureDraftRows,
} from "./CompilePreviewDialog";
import {
  compareFixturesCanonical,
  sortFixtureIdsCanonical,
  sortFixturesCanonical,
} from "../helpers/fixtureOrder";
import { FixturesToolbar } from "./FixturesToolbar";
import { fixtureColumns } from "../parts/fixtureColumns";
import { FixtureDetails } from "./FixtureDetails";
import { TeamStrengthDialog } from "./TeamStrengthDialog";
import { fetchFixtureMarketOdds } from "./OddsTooltip";
import {
  hasConsensusOddsIndication,
  readAggregatedMarketOdd,
} from "../helpers/fixtureMarketOdds";
import { HelpTerm } from "./HelpTerm";
import { extractFlag } from "./Help";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Button } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/Add";
import ExpandLessIcon from "@mui/icons-material/Remove";
import HistoryIcon from "@mui/icons-material/History";
import SearchIcon from "@mui/icons-material/Search";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import AwaitingCompilationIcon from "@mui/icons-material/HourglassEmpty";
import CompiledIcon from "@mui/icons-material/Addchart";
import CompilationConfirmedIcon from "@mui/icons-material/InsertChart";
import AwaitingEvaluationIcon from "@mui/icons-material/GppMaybe";
import EvaluationConfirmedIcon from "@mui/icons-material/CheckCircle";
import HelpIcon from "@mui/icons-material/Help";
import Grid from "@mui/material/Grid";
import { Padding } from "@mui/icons-material";
import { fi } from "date-fns/locale";
import {
  LeagueFixtureGoalAnalysis,
  LeagueMatchdayComparison,
} from "./LeagueMatchdayComparison";
import {
  FEATURES,
  hasFeatureAccess,
  getUserAccessLevel,
} from "../helpers/featureAccess";
import {
  BALANCED_LINE_OPTIONS,
  formatAsianHandicapLine,
  getFixtureHandicapLines,
  getFixtureLineSelection,
  getFixtureGoalLines,
  getDefaultHandicapSelection,
  hasStoredFairLine,
  mergeTemporaryFairLine,
  normalizeGoalLine,
  resolveGoalLineSelection,
  resolveHandicapLineSelection,
} from "../helpers/leagueFairMarkets";
import {
  getAutomaticLeagueAnalysisPhase,
  getManualLeagueAnalysisPhase,
} from "../helpers/leagueWorkspaceState";
import { withSeasonOccurredModelStatistics } from "../helpers/leagueMatchdayAnalysis";
import AsianHandicapMenu from "../parts/AsianHandicapMenu";
import { CompactLeagueTable } from "./CompactLeagueTable";
import { LeagueDisplay } from "./LeagueDisplay";
import { LeagueSeasonComparison } from "./LeagueSeasonComparison";
import {
  PerfectTipsFixtureValues,
  PerfectTipsHeader,
  PerfectTipsSummary,
} from "./PerfectTipsMarket";
import {
  calculatePerfectTipsGame,
  normalizeImpliedProbabilities,
  summarizePerfectTipsGames,
} from "../helpers/perfectTipsGame";
import { formatFixtureResult } from "../helpers/fixtureResult";
import { refreshLeagueEvaluationData } from "../helpers/leagueEvaluateRefresh";
import {
  buildDataUpdatePlan,
  buildDataUpdateTargets,
  diagnosisHasDataMaintenanceOpportunity,
  executeDataUpdatePlan,
  groupDataUpdateIssues,
} from "../helpers/myDataUpdate";
import {
  completedEvaluationResult,
  dataMaintenanceIssueDetails,
  readDataMaintenanceResponse,
} from "../helpers/dataMaintenanceResponse";
import MyDataUpdateDialog from "./AutomaticDataMaintenance";

const LEAGUE_WORKSPACE_GRID_COLUMNS =
  "26px 38px 112px minmax(180px, 1fr) 34px 60px minmax(0, 1.7fr)";
const LEAGUE_1X2_ODDS_GRID_COLUMNS =
  "repeat(3, minmax(0, 1fr))";
const LEAGUE_1X2_COMPARISON_GRID_COLUMNS =
  `${LEAGUE_1X2_ODDS_GRID_COLUMNS} 48px`;

export function FixturesOverview({
  entryRequest = null,
  onOverview,
  onLeagueSelection,
  leagues,
  allLeagues = [],
  user,
  dataMaintenanceRequest = 0,
  onDataMaintenanceStatusChange = () => {},
  onEvaluationRunningChange = () => {},
  teamStrengthsRevision = 0,
}) {
  const hasLeaguePostMatchComparison =
    hasFeatureAccess(
      FEATURES.LEAGUE_POST_MATCH_COMPARISON,
      user
    );

  const [showStats, setShowStats] = useState("hidden");
  const [showModal, setShowModal] = useState(false);

  const [evaluationResult, setEvaluationResult] =
    useState(null);

  const [
    showEvaluationDetails,
    setShowEvaluationDetails,
  ] = useState(false);

  const [
    creatingMissingTables,
    setCreatingMissingTables,
  ] = useState(false);

  const [
    missingTablesActionResult,
    setMissingTablesActionResult,
  ] = useState(null);

  const handleClose = () => {
    setShowModal(false);
    setShowEvaluationDetails(false);
    setMissingTablesActionResult(null);
  };

  const [selectionModel, setSelectionModel] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");
  const [missingCompetitions, setMissingCompetitions] = useState([]);
  const [pendingCompileIds, setPendingCompileIds] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState();
  const [compilePreview, setCompilePreview] = useState({
    open: false,
    fixtureIds: [],
    fixtures: [],
    missingSeasons: [],
    loading: false,
    running: false,
    calculationMethod: "standard",
    error: "",
    success: "",
  });
  const [reviewLeagueSettings, setReviewLeagueSettings] = useState(null);
  const [localTeamStrengthsRevision, setLocalTeamStrengthsRevision] = useState(0);
  const effectiveTeamStrengthsRevision = `${teamStrengthsRevision}:${localTeamStrengthsRevision}`;
  const compileConfirmationPending = useRef(false);
  const dataUpdateCancelRequested = useRef(false);
  const [globalDataUpdateAvailable, setGlobalDataUpdateAvailable] = useState(false);
  const [myDataUpdate, setMyDataUpdate] = useState({
    open: false,
    scope: "global",
    showDetails: false,
    running: false,
    stopping: false,
    progress: null,
    result: null,
    preview: null,
    evaluateHistorical: null,
    foundationConfirmation: false,
    foundationRunning: false,
  });

  /*
   * Eigener Evaluate-Fortschritt.
   *
   * loading bleibt für die übrigen bestehenden
   * Ladeoperationen erhalten.
   */
  const [evaluateProgress, setEvaluateProgress] =
    useState(null);
  const evaluationRunningRef = useRef(false);
  const evaluationRunning = Boolean(evaluateProgress);

  useEffect(() => {
    onEvaluationRunningChange(evaluationRunning);
    return () => onEvaluationRunningChange(false);
  }, [evaluationRunning, onEvaluationRunningChange]);

  const [startDate, setStartDate] = useState(initialFixtureDay);
  const [weekRange, setWeekRange] = useState(()=>weekSection());

  /*
   * --------------------------------------------------------
   * ZWEITER ARBEITSMODUS
   * --------------------------------------------------------
   *
   * "day" bleibt die bisherige Tagesansicht vollständig
   * unverändert.
   *
   * "league" ist die neue Liga-Arbeitsansicht.
   */
  const [teamAnalysisFixture,setTeamAnalysisFixture]=useState(null);
  const [workspaceMode, setWorkspaceMode] = useState(() => entryRequest?.mode || "day");
  const rangeStart = workspaceMode === "week" ? weekRange.start : startDate;
  const rangeEnd = workspaceMode === "week" ? weekRange.end : startDate;
  const displayRows = useMemo(()=>sortGames(rows,workspaceMode,leagues),[rows,workspaceMode,leagues]);
  const groupStarts = useMemo(()=>new Set(displayRows.filter((f,i)=>i===0 || Number(displayRows[i-1].league_id)!==Number(f.league_id)).map(f=>f.id)),[displayRows]);
  const readFrom = dateKey(addDays(rangeStart,-1)); // include Berlin's UTC boundary
  const readTo = dateKey(rangeEnd);

  const [selectedLeague, setSelectedLeague] =
    useState(null);

  /*
   * Liga-Auswahl wird nur bei Bedarf geöffnet.
   * Sie nimmt im normalen Arbeitsbereich keinen
   * dauerhaften Platz ein.
   */
  const [leagueSelectorAnchor, setLeagueSelectorAnchor] =
    useState(null);

  const [leagueSearch, setLeagueSearch] =
    useState("");

  const leagueSelectorOpen =
    Boolean(leagueSelectorAnchor);

  const [leagueSeason, setLeagueSeason] =
    useState(null);

  const [leagueSeasons, setLeagueSeasons] =
    useState([]);

  const [
    requestedLeagueSeasonId,
    setRequestedLeagueSeasonId,
  ] = useState(null);

  const [leagueRound, setLeagueRound] =
    useState(null);

  const [leagueRounds, setLeagueRounds] =
    useState([]);

  /*
   * null bedeutet: Beim Einstieg den aktuell relevanten
   * Spieltag automatisch bestimmen. Sobald der Nutzer
   * blättert oder direkt auswählt, steht hier die Round-ID.
   */
  const [requestedLeagueRoundId, setRequestedLeagueRoundId] =
    useState(null);

  const handledEntry = useRef(null);
  useEffect(() => {
    if (!entryRequest || handledEntry.current === entryRequest) return;
    if (entryRequest.mode === "league" && !entryRequest.leagueId) {
      setWorkspaceMode("league"); handledEntry.current = entryRequest; return;
    }
    if (["day","week"].includes(entryRequest.mode)) {
      setWorkspaceMode(entryRequest.mode);
      if(entryRequest.resetDate){setStartDate(today());setWeekRange(weekSection());}
      handledEntry.current = entryRequest; return;
    }
    const league = allLeagues?.find(item => Number(item.id) === Number(entryRequest.leagueId));
    if (!league || !leagues?.some(item => Number(item.id) === Number(league.id))) return;
    handledEntry.current = entryRequest;
    pendingAdminFixture.current = entryRequest.fixtureId || null;
    setRequestedLeagueSeasonId(entryRequest.seasonId || null);
    setRequestedLeagueRoundId(entryRequest.roundId || null);
    setSelectedLeague(league);
    setWorkspaceMode("league");
  }, [entryRequest, allLeagues, leagues]);

  const [leagueSettingsDirty, setLeagueSettingsDirty] = useState(false);
  const [fixtureDetailsRow, setFixtureDetailsRow] = useState(null);
  const [fixturesUpdatedAt, setFixturesUpdatedAt] = useState(null);
  const [fixturesRefreshing, setFixturesRefreshing] = useState(false);
  const [fixturesRefreshError, setFixturesRefreshError] = useState(false);
  const refreshFixturesRef = useRef(null);
  const fixturesRefreshBlocked = useRef(false);
  fixturesRefreshBlocked.current = evaluationRunning || leagueSettingsDirty || compilePreview.running;

  const pendingAdminFixture = useRef(null);

  const [leagueRows, setLeagueRows] =
    useState([]);

  const [selectedLeagueFixtureId, setSelectedLeagueFixtureId] =
    useState(null);

  /*
   * Eigene Multi-Auswahl der Liga-Arbeitsliste.
   * Sie ist bewusst unabhängig von der Selection
   * der bestehenden Tagesansicht.
   */
  const [leagueSelectionModel, setLeagueSelectionModel] =
    useState([]);

  const [leagueLoading, setLeagueLoading] =
    useState(false);

  const [leagueError, setLeagueError] =
    useState("");

  /*
   * Analysemodus der Liga-Arbeitsliste.
   *
   * Die eigentliche Fixture-Struktur bleibt immer gleich.
   * Nur der rechte Analysebereich wechselt seinen Inhalt.
   */
  const [leagueAnalysisPhase, setLeagueAnalysisPhase] =
    useState("pre");

  const [leagueAnalysisView, setLeagueAnalysisView] =
    useState("1x2");

  const [leagueGoalLine, setLeagueGoalLine] =
    useState("2.50");

  const [leagueGoalLineOverrides, setLeagueGoalLineOverrides] =
    useState({});

  const [leagueHandicapLine, setLeagueHandicapLine] =
    useState("0.00");

  const [leagueHandicapLineOverrides, setLeagueHandicapLineOverrides] =
    useState({});

  const [leaguePostMatchView, setLeaguePostMatchView] =
    useState("market");

  const [leaguePostMarketMode, setLeaguePostMarketMode] =
    useState("odds");

  const showLeaguePostMatchComparison =
    hasLeaguePostMatchComparison &&
    leagueAnalysisPhase === "post" &&
    leaguePostMatchView === "comparison";

  const showPerfectTipsMarket =
    leagueAnalysisPhase === "post" &&
    leaguePostMatchView === "market" &&
    leaguePostMarketMode === "perfect-tips" &&
    ["1x2", "over-under", "btts"].includes(leagueAnalysisView);

  /*
   * Basis für die sichtbare Marktquote.
   *
   * average = Durchschnitt der verfügbaren Buchmacher
   * highest = höchste gefundene Quote
   */
  const [leagueMarketBasis, setLeagueMarketBasis] =
    useState("average");

  /*
   * Sichtbare Darstellung der 1X2-Werte:
   *
   * odds       = Dezimalquoten
   * implied    = implizite Wahrscheinlichkeiten
   * normalized = Markt auf 100 Prozent normalisiert
   */
  const [leagueOddsDisplay, setLeagueOddsDisplay] =
    useState(() =>
      sessionStorage.getItem(
        "fixturesLeagueOddsDisplay"
      ) || "odds"
    );

  const [leaguePerfectTipsDisplay, setLeaguePerfectTipsDisplay] =
    useState("probabilities");

  /*
   * Mindestvorteil für eine sichtbare Indikation.
   *
   * Die Einstellung verändert ausschließlich die
   * Hervorhebung. Marktquoten werden niemals entfernt.
   */
  const [
    leagueIndicationThreshold,
    setLeagueIndicationThreshold,
  ] = useState(() => {
    const currentKey =
      "fixturesLeagueIndicationThresholdV2";

    const currentRaw =
      localStorage.getItem(currentKey);

    if (currentRaw !== null) {
      const current = Number(currentRaw);

      return Number.isFinite(current)
        ? current
        : 2;
    }

    const legacyRaw =
      localStorage.getItem(
        "fixturesLeagueIndicationThreshold"
      );

    const legacy = Number(legacyRaw);

    return legacyRaw !== null &&
      Number.isFinite(legacy) &&
      legacy > 0
      ? legacy
      : 2;
  });

  const [leagueStatisticModels, setLeagueStatisticModels] = useState({});
  const [leagueStatisticStatus, setLeagueStatisticStatus] = useState("idle");
  const [statisticReadErrors, setStatisticReadErrors] = useState({});
  const [statisticRefresh, setStatisticRefresh] = useState(0);
  const [statisticCompileFailures, setStatisticCompileFailures] = useState({});
  const statisticOwner = user?.user_id ?? user?.email ?? user?.id;
  const statisticScope = JSON.stringify((workspaceMode === "league" ? leagueRows : rows).map(row => [Number(row.id), Number(row.league_id), Number(row.season_id), row.statistic_model_applicable, row.status, row.evaluation_operation_state, row.evaluation_finalized, row.probs]));
  const statisticAllowed = hasFeatureAccess(FEATURES.STATISTICS_MODEL, user);
  useEffect(() => {
    let cancelled = false;
    setLeagueStatisticModels({});
    setStatisticReadErrors({});
    setLeagueStatisticStatus("idle");
    if (!statisticAllowed) return undefined;
    setLeagueStatisticStatus("loading");
    const rows = JSON.parse(statisticScope), groups = new Map();
    for (const [id, league, season, applicable] of rows) {
      if (applicable === false) continue;
      if (![id, league, season].every(n => Number.isSafeInteger(n) && n > 0)) continue;
      const key = `${league}:${season}`;
      if (!groups.has(key)) groups.set(key, {league_id:league, season_id:season, fixture_ids:[]});
      groups.get(key).fixture_ids.push(id);
    }
    (async () => {
      const models = {}, errors = {};
      for (const group of groups.values()) {
        for (let offset = 0; offset < group.fixture_ids.length; offset += 100) {
          try {
          const response = await fetchViaPost("statistic-model", JSON.stringify({...group, mode:"stored-fixtures", fixture_ids:group.fixture_ids.slice(offset,offset+100)}));
          const data = await response.json();
          if (!response.ok || data.success !== true) throw Error("STATISTICS_READ_UNAVAILABLE");
          for (const record of data.records || []) if (!statisticCompileFailures[String(record.pre.fixture_id)]) models[String(record.pre.fixture_id)] = {...record.pre, evaluation_recorded:!!record.evaluation};
          } catch { errors[`${group.league_id}:${group.season_id}`] = true; }
        }
      }
      if (!cancelled) { setLeagueStatisticModels(models); setStatisticReadErrors(errors); setLeagueStatisticStatus(Object.keys(errors).length && !Object.keys(models).length ? "error" : "ready"); }
    })().catch(() => { if (!cancelled) { setLeagueStatisticModels({}); setLeagueStatisticStatus("error"); } });
    return () => { cancelled = true; };
  }, [workspaceMode, statisticScope, statisticAllowed, statisticOwner, statisticRefresh, statisticCompileFailures]);

  const [leagueMarketOdds, setLeagueMarketOdds] =
    useState({});

  const [leagueMarketLoading, setLeagueMarketLoading] =
    useState(false);

  const [
    leagueSeasonComparison,
    setLeagueSeasonComparison,
  ] = useState(null);

  const [leagueSeasonBase, setLeagueSeasonBase] = useState(null);
  const [leagueStrengthRanking, setLeagueStrengthRanking] = useState([]);
  const [leagueSeasonFixtures, setLeagueSeasonFixtures] = useState([]);

  async function refreshLeagueStrengthRanking(fixtures, stageId) {
    const normalizedStageId = Number(stageId);
    if (!Number.isFinite(normalizedStageId)) {
      setLeagueStrengthRanking([]);
      return;
    }

    const names = new Map();
    fixtures
      .filter((fixture) => Number(fixture?.stage_id) === normalizedStageId)
      .forEach((fixture) => {
        [getParticipant(fixture, "home"), getParticipant(fixture, "away")]
          .forEach((team) => {
            if (team?.id && team?.placeholder !== true) {
              names.set(Number(team.id), team.name);
            }
          });
      });

    const result = await fetchViaPost("get-team-strengths", JSON.stringify({
      season_id: Number(fixtures[0]?.season_id),
      team_ids: [...names.keys()],
    })).then((response) => response.json());

    setLeagueStrengthRanking(rankTeamSettings(Object.entries(result || {}).map(
      ([teamId, settings]) => ({
        ...settings,
        team_id: Number(teamId),
        team_name: names.get(Number(teamId)),
      })
    )));
  }

  useEffect(() => {
    sessionStorage.setItem(
      "fixturesLeagueOddsDisplay",
      leagueOddsDisplay
    );
  }, [leagueOddsDisplay]);

  useEffect(() => {
    localStorage.setItem(
      "fixturesLeagueIndicationThresholdV2",
      String(leagueIndicationThreshold)
    );
  }, [leagueIndicationThreshold]);





  useEffect(() => {
    sessionStorage.setItem(
      "fixturesWorkspaceMode",
      workspaceMode
    );
  }, [workspaceMode]);


  useEffect(() => {
    if (!selectedLeague?.id) {
      return;
    }

    sessionStorage.setItem(
      "fixturesSelectedLeagueId",
      String(selectedLeague.id)
    );
  }, [selectedLeague?.id]);


  function isLeagueAccessible(league) {
    return leagues.some(
      (allowed) =>
        Number(allowed.id) ===
        Number(league?.id)
    );
  }


  function getLeagueFlag(league) {
    try {
      if (!league?.country?.extra) {
        return null;
      }

      return extractFlag(
        league.country.extra
      );
    } catch {
      return null;
    }
  }


  /*
   * Verbindliche betty-Standardreihenfolge.
   *
   * NICHT alphabetisch.
   * Die individuelle User-Reihenfolge kommt
   * später über einen eigenen Prioritäteneditor.
   */
  const normalizedLeagueSearch =
    leagueSearch
      .trim()
      .toLocaleLowerCase();


  const visibleLeagueOptions =
    [...allLeagues]
      .filter((league) => {
        if (!normalizedLeagueSearch) {
          return true;
        }

        const haystack =
          [
            league?.name,
            getLeagueCountryName(
              league
            ),
          ]
            .filter(Boolean)
            .join(" ")
            .toLocaleLowerCase();

        return haystack.includes(
          normalizedLeagueSearch
        );
      })
      .sort(compareLeagueSelection);


  const groupedLeagueOptions =
    visibleLeagueOptions.reduce(
      (groups, league) => {
        const country =
          getLeagueCountryName(
            league
          );

        if (!groups[country]) {
          groups[country] = [];
        }

        groups[country].push(
          league
        );

        return groups;
      },
      {}
    );


  function getParticipant(
    fixture,
    location
  ) {
    return fixture
      ?.participants
      ?.find(
        (participant) =>
          participant
            ?.meta
            ?.location === location
      );
  }


  function formatFairOdd(probability) {
    const value =
      Number(probability);

    if (
      !Number.isFinite(value) ||
      value <= 0
    ) {
      return "–";
    }

    return (
      1 / value
    ).toFixed(2);
  }


  /*
   * Exakt dieselbe bisherige Zeitlogik wie in
   * der bestehenden Tagesansicht.
   */
  function getFixtureStateCode(
    fixture
  ) {
    return String(
      fixture
        ?.state
        ?.state ||
      fixture
        ?.state
        ?.short_name ||
      fixture
        ?.state
        ?.developer_name ||
      ""
    ).toUpperCase();
  }


  function getScoreByDescription(
    fixture,
    description
  ) {
    const scores =
      Array.isArray(
        fixture?.scores
      )
        ? fixture.scores
        : [];

    const wanted =
      String(
        description
      ).toUpperCase();

    let home = null;
    let away = null;

    for (
      const item of scores
    ) {
      if (
        String(
          item?.description ||
          ""
        ).toUpperCase() !==
        wanted
      ) {
        continue;
      }

      const participant =
        String(
          item
            ?.score
            ?.participant ||
          ""
        ).toLowerCase();

      const goals =
        Number(
          item
            ?.score
            ?.goals
        );

      if (
        !Number.isFinite(
          goals
        )
      ) {
        continue;
      }

      if (
        participant ===
        "home"
      ) {
        home = goals;
      }

      if (
        participant ===
        "away"
      ) {
        away = goals;
      }
    }

    if (
      home === null ||
      away === null
    ) {
      return null;
    }

    return {
      home,
      away,
    };
  }


  function isFinishedFixture(
    fixture
  ) {
    const state =
      getFixtureStateCode(
        fixture
      );

    return [
      "FT",
      "FT_PEN",
      "AET",
    ].includes(
      state
    );
  }


  function isPreMatchFixture(
    fixture
  ) {
    const state =
      getFixtureStateCode(
        fixture
      );

    return [
      "NS",
      "TBA",
      "POSTP",
      "POSTPONED",
    ].includes(
      state
    );
  }


  function isLiveFixture(
    fixture
  ) {
    const state =
      getFixtureStateCode(
        fixture
      );

    if (
      !state ||
      isFinishedFixture(
        fixture
      ) ||
      isPreMatchFixture(
        fixture
      )
    ) {
      return false;
    }

    if (
      [
        "CANCELLED",
        "CANCELED",
        "CAN",
        "ABD",
        "ABANDONED",
        "WO",
      ].includes(
        state
      )
    ) {
      return false;
    }

    return true;
  }


  function getLiveMinute(
    fixture
  ) {
    const candidates = [
      fixture?.time?.minute,
      fixture?.minute,
      fixture?.minutes,
      fixture?.periods
        ?.find?.(
          (period) =>
            period?.ticking ===
            true
        )
        ?.minutes,
    ];

    for (
      const candidate of candidates
    ) {
      const number =
        Number(
          candidate
        );

      if (
        Number.isFinite(
          number
        ) &&
        number >= 0
      ) {
        return Math.floor(
          number
        );
      }
    }

    return null;
  }


  function getFixtureResultText(
    fixture
  ) {
    return formatFixtureResult(fixture);
  }


  function getFixtureStatusLabel(
    fixture
  ) {
    if (
      isFinishedFixture(
        fixture
      )
    ) {
      return "FT";
    }

    if (
      isLiveFixture(
        fixture
      )
    ) {
      const state =
        getFixtureStateCode(
          fixture
        );

      if (
        state === "HT" ||
        state.includes(
          "HALF_TIME"
        ) ||
        state.includes(
          "HALFTIME"
        )
      ) {
        return "HT";
      }

      const minute =
        getLiveMinute(
          fixture
        );

      return minute !== null
        ? `LIVE ${minute}′`
        : "LIVE";
    }

    const state =
      getFixtureStateCode(
        fixture
      );

    if (
      state === "POSTP" ||
      state === "POSTPONED"
    ) {
      return "verlegt";
    }

    if (
      state === "TBA"
    ) {
      return "TBA";
    }

    return "";
  }


  function getFinishedOutcome(
    fixture
  ) {
    if (
      !isFinishedFixture(
        fixture
      )
    ) {
      return null;
    }

    const current =
      getScoreByDescription(
        fixture,
        "CURRENT"
      );

    if (!current) {
      return null;
    }

    if (
      current.home >
      current.away
    ) {
      return "1";
    }

    if (
      current.home <
      current.away
    ) {
      return "2";
    }

    return "X";
  }


  function getAnalysisLabel() {
    if (
      leagueAnalysisView ===
      "1x2"
    ) {
      return "1X2";
    }

    if (
      leagueAnalysisView ===
      "over-under"
    ) {
      return "Over / Under";
    }

    if (
      leagueAnalysisView ===
      "btts"
    ) {
      return "Both Teams to Score";
    }

    if (
      leagueAnalysisView ===
      "should-goals"
    ) {
      return "Should Goals";
    }

    return "Analyse";
  }


  /*
   * "Aktueller Spieltag" wird NICHT einfach über
   * das nächste einzelne Fixture bestimmt.
   *
   * Das wäre bei Nachholspielen / Verlegungen
   * zu anfällig.
   *
   * Stattdessen gruppieren wir nach Round und
   * vergleichen den mittleren Termin der gesamten
   * Runde mit dem heutigen Datum.
   *
   * Dadurch zieht ein einzelnes verlegtes Spiel
   * einen alten Spieltag nicht automatisch nach vorn.
   */
  function findCurrentRound(fixtures) {
    const grouped =
      new Map();

    for (const fixture of fixtures) {
      const roundId =
        Number(
          fixture?.round_id ??
          fixture?.round?.id
        );

      if (!Number.isFinite(roundId)) {
        continue;
      }

      if (!grouped.has(roundId)) {
        grouped.set(
          roundId,
          {
            id: roundId,
            name:
              fixture?.round?.name ??
              String(roundId),
            fixtures: [],
          }
        );
      }

      grouped
        .get(roundId)
        .fixtures
        .push(fixture);
    }

    const now =
      Date.now();

    const rounds =
      [...grouped.values()]
        .map((round) => {
          const timestamps =
            round.fixtures
              .map(
                (fixture) =>
                  new Date(
                    fixture?.starting_at
                  ).getTime()
              )
              .filter(
                (value) =>
                  Number.isFinite(value)
              )
              .sort(
                (a, b) =>
                  a - b
              );

          if (!timestamps.length) {
            return null;
          }

          const middle =
            Math.floor(
              timestamps.length / 2
            );

          const median =
            timestamps.length % 2
              ? timestamps[middle]
              : (
                  timestamps[
                    middle - 1
                  ] +
                  timestamps[
                    middle
                  ]
                ) / 2;

          return {
            ...round,
            median,
            distance:
              Math.abs(
                median - now
              ),
          };
        })
        .filter(Boolean)
        .sort(
          (a, b) =>
            a.distance -
            b.distance
        );

    return rounds[0] || null;
  }


  function getAvailableLeagueRounds(fixtures) {
    const grouped = new Map();

    for (const fixture of fixtures) {
      const roundId = Number(
        fixture?.round_id ??
        fixture?.round?.id
      );

      if (!Number.isFinite(roundId)) {
        continue;
      }

      if (!grouped.has(roundId)) {
        grouped.set(roundId, {
          id: roundId,
          name:
            fixture?.round?.name ??
            String(roundId),
          firstKickoff: Number.POSITIVE_INFINITY,
        });
      }

      const kickoff = new Date(
        fixture?.starting_at
      ).getTime();

      if (Number.isFinite(kickoff)) {
        const round = grouped.get(roundId);

        round.firstKickoff = Math.min(
          round.firstKickoff,
          kickoff
        );
      }
    }

    return [...grouped.values()].sort(
      (a, b) => {
        const aNumber = Number(
          String(a.name).match(/\d+/)?.[0]
        );

        const bNumber = Number(
          String(b.name).match(/\d+/)?.[0]
        );

        if (
          Number.isFinite(aNumber) &&
          Number.isFinite(bNumber) &&
          aNumber !== bNumber
        ) {
          return aNumber - bNumber;
        }

        return a.firstKickoff - b.firstKickoff;
      }
    );
  }


  /*
   * Ausschließlich bereits gespeicherte Werte laden.
   * Keine Tabelle und keine Statistik wird hier
   * neu aufgebaut.
   */
  async function fetchLeagueSeasonComparison(
    leagueId,
    seasonId
  ) {
    const response =
      await fetchViaPost(
        "build-user-season-stats",
        JSON.stringify({
          mode: "load",
          league_id:
            Number(leagueId),
          season_id:
            Number(seasonId),
        })
      );

    const result =
      await response.json();

    if (
      !response.ok ||
      !result?.success
    ) {
      throw new Error(
        result?.message ||
        "Saisonvergleich konnte nicht geladen werden."
      );
    }

    return result;
  }


  /*
   * Liga-Ansicht:
   *
   * 1. aktuelle Saison der gewählten Liga
   * 2. komplette Season-Fixture-Liste
   * 3. aktuellen Spieltag bestimmen
   * 4. NUR für diesen Spieltag die vorhandenen
   *    User-/FIXTURE_ODDS-Details laden
   *
   * Dadurch fragen wir die betty-Details nicht
   * unnötig für die komplette Saison ab.
   */
  useEffect(() => {
    if (
      workspaceMode !== "league" ||
      !selectedLeague?.id ||
      !isLeagueAccessible(
        selectedLeague
      )
    ) {
      return;
    }

    let cancelled =
      false;

    async function fetchLeagueWorkspace() {
      setLeagueLoading(true);
      setLeagueError("");
      setLeagueRows([]);
      setLeagueMarketOdds({});
      setLeagueSeasonComparison(null);
      setLeagueSeasonBase(null);
      setLeagueStrengthRanking([]);
      setLeagueSeason(null);
      setLeagueRound(null);
      setLeagueRounds([]);
      setSelectedLeagueFixtureId(null);
      setLeagueSelectionModel([]);

      try {
        const leagueResponse =
          await (
            await fetchFromApi(
              "fetch-data-v3/leagues/" +
                selectedLeague.id +
                "?per_page=50&include=seasons"
            )
          ).json();

        const availableSeasons =
          [
            ...(
              leagueResponse
                ?.data
                ?.seasons ??
              []
            ),
          ]
            .filter(
              (season) =>
                Number.isFinite(
                  Number(
                    season?.id
                  )
                )
            )
            .sort(
              (a, b) => {
                const aStart =
                  new Date(
                    a?.starting_at ??
                    a?.start_date ??
                    ""
                  ).getTime();

                const bStart =
                  new Date(
                    b?.starting_at ??
                    b?.start_date ??
                    ""
                  ).getTime();

                if (
                  Number.isFinite(aStart) &&
                  Number.isFinite(bStart) &&
                  aStart !== bStart
                ) {
                  return aStart - bStart;
                }

                return (
                  Number(a.id) -
                  Number(b.id)
                );
              }
            );

        const requestedSeason =
          availableSeasons.find(
            (season) =>
              Number(season.id) ===
              Number(
                requestedLeagueSeasonId
              )
          );

        const selectedSeason =
          requestedSeason ||
          availableSeasons.find(
            (season) =>
              season?.is_current === true
          ) ||
          availableSeasons[
            availableSeasons.length - 1
          ];

        if (!selectedSeason) {
          throw new Error(
            i18next.t(
              "help.leagueWorkspace.noSeason"
            )
          );
        }

        let seasonComparison =
          null;

        try {
          seasonComparison =
            await fetchLeagueSeasonComparison(
              selectedLeague.id,
              selectedSeason.id
            );
        } catch (error) {
          console.warn(
            "[League season comparison]",
            error
          );
        }

        const seasonResponse =
          await (
            await fetchFromApi(
              `fetch-data-v3/seasons/${selectedSeason.id}` +
                "?include=" +
                "fixtures.state;" +
                "fixtures.participants;" +
                "fixtures.scores;" +
                "fixtures.round"
            )
          ).json();

        const seasonFixtures =
          seasonResponse
            ?.data
            ?.fixtures ??
          [];

        const [seasonBaseResult] = await Promise.all([
          fetchViaPost("get-season-base-stats", JSON.stringify({
            league_id: Number(selectedLeague.id),
            season_id: Number(selectedSeason.id),
            fast_read: true,
          })).then((response) => response.json()).catch(() => null),
        ]);

        seasonComparison = withSeasonOccurredModelStatistics(
          seasonComparison,
          seasonFixtures
        );

        if (!seasonFixtures.length) {
          throw new Error(
            "Für die gewählte Saison wurden keine Fixtures gefunden."
          );
        }

        const availableRounds =
          getAvailableLeagueRounds(
            seasonFixtures
          );

        const automaticallySelectedRound =
          findCurrentRound(
            seasonFixtures
          );

        const requestedRound =
          availableRounds.find(
            (round) =>
              Number(round.id) ===
              Number(requestedLeagueRoundId)
          );

        const currentRound =
          availableRounds.find(round => Number(round.id) === Number(
            seasonFixtures.find(fixture => Number(fixture.id) === Number(pendingAdminFixture.current))?.round_id
          )) || requestedRound ||
          automaticallySelectedRound;

        let roundFixtures;

        if (currentRound) {
          roundFixtures =
            seasonFixtures.filter(
              (fixture) =>
                Number(
                  fixture?.round_id ??
                  fixture?.round?.id
                ) ===
                Number(
                  currentRound.id
                )
            );
        } else {
          /*
           * Fallback nur für Wettbewerbe ohne
           * brauchbare Round-Daten:
           * die zeitlich nächsten Fixtures.
           */
          roundFixtures =
            [...seasonFixtures]
              .sort(
                (a, b) => {
                  const distanceDifference =
                    Math.abs(
                    new Date(
                      a?.starting_at
                    ).getTime() -
                    Date.now()
                  ) -
                  Math.abs(
                    new Date(
                      b?.starting_at
                    ).getTime() -
                    Date.now()
                  );

                  return distanceDifference || compareFixturesCanonical(a, b);
                }
              )
              .slice(0, 12);
        }

        roundFixtures = sortFixturesCanonical(roundFixtures);

        const displayedStageId = Number(roundFixtures[0]?.stage_id);
        const displayedStageFixtures = Number.isFinite(displayedStageId)
          ? seasonFixtures.filter(
              (fixture) => Number(fixture?.stage_id) === displayedStageId
            )
          : [];
        const stageTeamNames = new Map();
        displayedStageFixtures.forEach((fixture) => {
          [getParticipant(fixture, "home"), getParticipant(fixture, "away")]
            .forEach((team) => {
              if (team?.id && team?.placeholder !== true) {
                stageTeamNames.set(Number(team.id), team.name);
              }
            });
        });
        const strengthResult = Number.isFinite(displayedStageId)
          ? await fetchViaPost("get-team-strengths", JSON.stringify({
              season_id: Number(selectedSeason.id),
              team_ids: [...stageTeamNames.keys()],
            })).then((response) => response.json())
          : {};
        const strengthRows = rankTeamSettings(Object.entries(strengthResult || {}).map(
          ([teamId, settings]) => ({
            ...settings,
            team_id: Number(teamId),
            team_name: stageTeamNames.get(Number(teamId)),
          })
        ));

        const requestFixtures =
          roundFixtures.map(
            (fixture) => {
              const home =
                getParticipant(
                  fixture,
                  "home"
                );

              const away =
                getParticipant(
                  fixture,
                  "away"
                );

              return {
                id:
                  fixture.id,

                league_id:
                  selectedLeague.id,

                localteam_id:
                  home?.id,

                visitorteam_id:
                  away?.id,
              };
            }
          );

        let details =
          [];

        if (requestFixtures.length) {
          const detailsResponse =
            await fetchViaPost(
              "get-details-for-fixtures",
              JSON.stringify({
                season_id:
                  selectedSeason.id,
                fixtures:
                  requestFixtures,
              })
            );

          details =
            await detailsResponse.json();

          if (!Array.isArray(details)) {
            details = [];
          }
        }

        const preparedRows =
          roundFixtures.map(
            (fixture) => {
              const detail =
                details.find(
                  (item) =>
                    Number(item?.id) ===
                    Number(fixture.id)
                ) || {};

              const home =
                getParticipant(
                  fixture,
                  "home"
                ) || {};

              const away =
                getParticipant(
                  fixture,
                  "away"
                ) || {};

              const homeCustom =
                detail
                  ?.teams
                  ?.find(
                    (team) =>
                      Number(team?.id) ===
                      Number(home?.id)
                  )
                  ?.custom_name;

              const awayCustom =
                detail
                  ?.teams
                  ?.find(
                    (team) =>
                      Number(team?.id) ===
                      Number(away?.id)
                  )
                  ?.custom_name;

              return {
                ...fixture,
                ...detail,

                season_id:
                  selectedSeason.id,

                league_id:
                  selectedLeague.id,

                league: {
                  ...selectedLeague,
                  id:
                    selectedLeague.id,
                },

                details: {
                  date:
                    getGermanFixtureDate(
                      fixture.starting_at
                    ),
                  id:
                    fixture.id,
                },

                user: {
                  user,
                },

                localTeam: {
                  ...home,
                  custom_name:
                    homeCustom &&
                    homeCustom !==
                      "NO_CUSTOM_NAME"
                      ? homeCustom
                      : home?.name,
                },

                visitorTeam: {
                  ...away,
                  custom_name:
                    awayCustom &&
                    awayCustom !==
                      "NO_CUSTOM_NAME"
                      ? awayCustom
                      : away?.name,
                },

                goalexp:
                  detail?.goalexp,

                status:
                  detail?.status,

                ...(
                  detail?.probs ||
                  {}
                ),
              };
            }
          );

        if (cancelled) {
          return;
        }

        setLeagueSeasons(
          availableSeasons
        );

        setLeagueSeason(
          selectedSeason
        );

        setLeagueSeasonComparison(
          seasonComparison
        );

        setLeagueSeasonBase(seasonBaseResult?.record || null);
        setLeagueSeasonFixtures(seasonFixtures);
        setLeagueStrengthRanking(strengthRows);

        setLeagueRound(
          currentRound
        );

        setLeagueRounds(
          availableRounds
        );

        setLeagueRows(
          preparedRows
        );

        const automaticAnalysisPhase =
          getAutomaticLeagueAnalysisPhase(roundFixtures);
        setLeagueAnalysisPhase(automaticAnalysisPhase);
        setLeaguePostMatchView(
          automaticAnalysisPhase === "post" && hasLeaguePostMatchComparison
            ? "comparison"
            : "market"
        );

        setSelectedLeagueFixtureId(
          preparedRows.find(row => Number(row.id) === Number(pendingAdminFixture.current))?.id ?? preparedRows[0]?.id ?? null
        );
        pendingAdminFixture.current = null;
      } catch (error) {
        if (cancelled) {
          return;
        }

        console.error(
          "[League workspace]",
          error
        );

        setLeagueError(
          error?.message ||
          "Liga-Ansicht konnte nicht geladen werden."
        );
      } finally {
        if (!cancelled) {
          setLeagueLoading(false);
        }
      }
    }

    fetchLeagueWorkspace();

    return () => {
      cancelled = true;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    workspaceMode,
    selectedLeague?.id,
    requestedLeagueSeasonId,
    requestedLeagueRoundId,
    entryRequest,
  ]);


  const refreshAdminLeagueResults = useCallback(async (isActive) => {
    if (!leagueSeason?.id) return;
    const response = await fetchFromApi(`fetch-data-v3/seasons/${leagueSeason.id}?include=fixtures.state;fixtures.participants;fixtures.scores;fixtures.round`);
    if (!response.ok) throw new Error("Ergebnisse konnten nicht aktualisiert werden.");
    const data = await response.json();
    if (!Array.isArray(data?.data?.fixtures)) throw new Error("Keine gültigen Fixture-Daten erhalten.");
    if (!isActive()) return;
    setLeagueSeasonFixtures(data.data.fixtures);
    setLeagueSeasonComparison(current => withSeasonOccurredModelStatistics(current, data.data.fixtures));
    setLeagueRows(current => mergeLeagueFixtureTruth(current, data.data.fixtures));
  }, [leagueSeason?.id]);

  const leagueSeasonIndex =
    leagueSeasons.findIndex(
      (season) =>
        Number(season.id) ===
        Number(leagueSeason?.id)
    );


  function selectNeighbourLeagueSeason(
    offset
  ) {
    const nextSeason =
      leagueSeasons[
        leagueSeasonIndex + offset
      ];

    if (!nextSeason) {
      return;
    }

    setRequestedLeagueSeasonId(
      nextSeason.id
    );

    setRequestedLeagueRoundId(
      null
    );
  }


  const leagueRoundIndex =
    leagueRounds.findIndex(
      (round) =>
        Number(round.id) ===
        Number(leagueRound?.id)
    );


  function selectNeighbourLeagueRound(offset) {
    const nextRound =
      leagueRounds[
        leagueRoundIndex + offset
      ];

    if (!nextRound) {
      return;
    }

    setRequestedLeagueRoundId(
      nextRound.id
    );
  }


  const selectedLeagueFixture =
    leagueRows.find(
      (row) =>
        Number(row.id) ===
        Number(
          selectedLeagueFixtureId
        )
    ) ||
    leagueRows[0] ||
    null;


  useEffect(() => {
    if (
      workspaceMode !==
        "league" ||
      !["1x2", "over-under", "asian-handicap", "btts", "double-chance"].includes(
        leagueAnalysisView
      ) ||
      !leagueRows.length
    ) {
      return;
    }

    let cancelled =
      false;

    async function loadLeagueMarketOdds() {
      setLeagueMarketLoading(
        true
      );

      try {
        const entries =
          await Promise.all(
            leagueRows.map(
              async (row) => {
                try {
                  const selectedLine =
                    leagueAnalysisView === "over-under"
                      ? (
                          getFixtureLineSelection(
                            row.id,
                            leagueGoalLine,
                            leagueGoalLineOverrides
                          )
                        ) === "market-balanced"
                        ? "market-balanced"
                        : resolveGoalLineSelection(
                            row,
                            null,
                            getFixtureLineSelection(
                              row.id,
                              leagueGoalLine,
                              leagueGoalLineOverrides
                            )
                          )
                      : leagueAnalysisView === "asian-handicap"
                        ? resolveHandicapLineSelection(
                            row,
                            getFixtureLineSelection(
                              row.id,
                              leagueHandicapLine,
                              leagueHandicapLineOverrides
                            )
                          )
                        : null;
                  const odds =
                    await fetchFixtureMarketOdds(
                      row.id,
                      leagueAnalysisView,
                      { line: selectedLine }
                    );
                  const effectiveLine = selectedLine === "market-balanced"
                    ? odds?.line
                    : selectedLine;
                  let fairLine = null;
                  if (
                    ["over-under", "asian-handicap"].includes(leagueAnalysisView) &&
                    effectiveLine &&
                    !hasStoredFairLine(row, leagueAnalysisView, effectiveLine)
                  ) {
                    const fairResponse = await fetchViaPost(
                      "get-fixture-fair-line",
                      JSON.stringify({
                        fixture_id: row.id,
                        market: leagueAnalysisView,
                        line: effectiveLine,
                      })
                    );
                    const fairResult = await fairResponse.json();
                    if (fairResponse.ok && fairResult?.success) {
                      fairLine = fairResult;
                    }
                  }

                  return [
                    String(
                      row.id
                    ),
                    { odds, fairLine },
                  ];
                } catch (
                  error
                ) {
                  console.error(
                    "[League market odds]",
                    row.id,
                    error
                  );

                  return [
                    String(
                      row.id
                    ),
                    null,
                  ];
                }
              }
            )
          );

        if (cancelled) {
          return;
        }

        setLeagueMarketOdds(Object.fromEntries(
          entries.map(([fixtureId, result]) => [fixtureId, result?.odds ?? null])
        ));
        const fairLines = new Map(entries
          .filter(([, result]) => result?.fairLine)
          .map(([fixtureId, result]) => [fixtureId, result.fairLine]));
        if (fairLines.size) {
          setLeagueRows((currentRows) => currentRows.map((row) => {
            const result = fairLines.get(String(row.id));
            return result
              ? mergeTemporaryFairLine(row, result.market, result.line, result.values)
              : row;
          }));
        }
      } finally {
        if (!cancelled) {
          setLeagueMarketLoading(
            false
          );
        }
      }
    }

    loadLeagueMarketOdds();

    return () => {
      cancelled = true;
    };
  }, [
    workspaceMode,
    leagueAnalysisView,
    leagueGoalLine,
    leagueGoalLineOverrides,
    leagueHandicapLine,
    leagueHandicapLineOverrides,
    leagueRows,
  ]);


  function getFairOddValue(
    row,
    outcome
  ) {
    const probability =
      outcome === "1"
        ? Number(
            row?.homewin
          )
        : outcome === "X"
        ? Number(
            row?.draw
          )
        : Number(
            row?.awaywin
          );

    if (
      !Number.isFinite(
        probability
      ) ||
      probability <= 0
    ) {
      return null;
    }

    return (
      1 /
      probability
    );
  }


  function getLeagueMarketOdd(
    row,
    outcome
  ) {
    if (leagueMarketOdds[String(row.id)]?.market !== leagueAnalysisView) return null;
    return readAggregatedMarketOdd(
      leagueMarketOdds[
        String(row.id)
      ],
      outcome,
      leagueMarketBasis
    );
  }

  function getSelectedGoalLine(row) {
    const market = leagueMarketOdds[String(row.id)];
    const selection = getFixtureLineSelection(
      row.id,
      leagueGoalLine,
      leagueGoalLineOverrides
    );
    return selection === "market-balanced"
      ? normalizeGoalLine(market?.line)
      : resolveGoalLineSelection(row, market, selection);
  }

  function getSelectedHandicapLine(row) {
    return resolveHandicapLineSelection(
      row,
      getFixtureLineSelection(
        row.id,
        leagueHandicapLine,
        leagueHandicapLineOverrides
      )
    );
  }

  function getGlobalGoalLines() {
    return [
      ...new Set(
        leagueRows.flatMap((row) =>
          getFixtureGoalLines(row, leagueMarketOdds[String(row.id)])
        )
      ),
    ].sort((a, b) => Number(a) - Number(b));
  }

  function getGlobalHandicapLines() {
    return [
      ...new Set(
        leagueRows.flatMap((row) =>
          getFixtureHandicapLines(row, leagueMarketOdds[String(row.id)])
        )
      ),
    ].sort((a, b) => Number(a) - Number(b));
  }

  function getLeagueAnalysisOutcomes() {
    if (leagueAnalysisView === "double-chance") return ["1X", "12", "X2"];
    if (leagueAnalysisView === "over-under") {
      return ["over", "under"];
    }
    if (leagueAnalysisView === "asian-handicap") {
      return ["home", "away"];
    }
    if (leagueAnalysisView === "btts") {
      return ["yes", "no"];
    }
    return ["1", "X", "2"];
  }

  function getLeagueBettyOdd(
    row,
    outcome
  ) {
    if (leagueAnalysisView === "double-chance") return storedModelOdd(row, leagueAnalysisView, outcome);
    if (leagueAnalysisView === "1x2") {
      return getFairOddValue(
        row,
        outcome
      );
    }
    if (leagueAnalysisView === "over-under") {
      const line = getSelectedGoalLine(row);
      const number = Number(
        row?.fair_markets?.asian_goal_lines?.lines?.[line]?.[outcome]
      );
      return Number.isFinite(number) && number > 0
        ? number
        : null;
    }
    if (leagueAnalysisView === "asian-handicap") {
      const line = getSelectedHandicapLine(row);
      const number = Number(
        row?.fair_markets?.asian_handicaps?.lines?.[line]?.[outcome]
      );
      return Number.isFinite(number) && number > 0 ? number : null;
    }
    if (leagueAnalysisView === "btts") {
      const number = Number(
        row?.fair_markets?.btts?.[outcome]
      );
      return Number.isFinite(number) && number > 0
        ? number
        : null;
    }
    return null;
  }


  function getLeagueMarketProbability(
    row,
    outcome
  ) {
    const odd =
      getLeagueMarketOdd(
        row,
        outcome
      );

    return Number.isFinite(odd) &&
      odd > 0
      ? 1 / odd
      : null;
  }


  function getLeagueMarketProbabilitySum(
    row
  ) {
    const values = getLeagueAnalysisOutcomes()
      .map((outcome) =>
        getLeagueMarketProbability(
          row,
          outcome
        )
      );

    return values.every(
      Number.isFinite
    )
      ? values.reduce(
          (sum, value) =>
            sum + value,
          0
        )
      : null;
  }

  function getPerfectTipsResult(row) {
    let realizedOutcome = getFinishedOutcome(row);
    if (realizedOutcome === null) return null;
    const outcomes = getLeagueAnalysisOutcomes();
    let betty = Object.fromEntries(outcomes.map((outcome) => [
      outcome,
      1 / getLeagueBettyOdd(row, outcome),
    ]));
    if (leagueAnalysisView === "1x2") {
      betty = {
        "1": Number(row?.homewin),
        X: Number(row?.draw),
        "2": Number(row?.awaywin),
      };
    } else {
      const score = getScoreByDescription(row, "CURRENT");
      if (!score) return null;
      if (leagueAnalysisView === "btts") {
        realizedOutcome = score.home > 0 && score.away > 0 ? "yes" : "no";
      } else if (leagueAnalysisView === "over-under") {
        const line = Number(getSelectedGoalLine(row));
        const total = score.home + score.away;
        if (!Number.isFinite(line) || total === line) return null;
        realizedOutcome = total > line ? "over" : "under";
      }
    }
    const market100 = normalizeImpliedProbabilities(
      Object.fromEntries(
        outcomes.map((outcome) => [
          outcome,
          getLeagueMarketProbability(row, outcome),
        ])
      )
    );
    return calculatePerfectTipsGame(
      betty,
      market100,
      realizedOutcome
    );
  }


  function getLeagueDisplayedValue(
    row,
    outcome,
    source
  ) {
    if (source === "statistic") {
      const odd = storedModelOdd(leagueStatisticModels[String(row.id)], leagueAnalysisView, outcome,
        leagueAnalysisView === "over-under" ? getSelectedGoalLine(row) : getSelectedHandicapLine(row));
      return odd === null ? "–" : leagueOddsDisplay === "odds" ? odd.toFixed(2) : `${(100 / odd).toFixed(1)} %`;
    }
    if (
      leagueOddsDisplay ===
      "odds"
    ) {
      const odd =
        source === "betty"
          ? getLeagueBettyOdd(
              row,
              outcome
            )
          : getLeagueMarketOdd(
              row,
              outcome
            );

      if (!Number.isFinite(odd)) {
        return "–";
      }

      return source === "betty"
        ? odd.toFixed(2)
        : odd.toFixed(2);
    }

    let probability =
      source === "betty"
        ? 1 /
          getLeagueBettyOdd(
            row,
            outcome
          )
        : getLeagueMarketProbability(
            row,
            outcome
          );

    if (
      leagueOddsDisplay ===
        "normalized" &&
      source === "market"
    ) {
      probability = normalizeImpliedProbabilities(
        Object.fromEntries(
          getLeagueAnalysisOutcomes().map((marketOutcome) => [
            marketOutcome,
            getLeagueMarketProbability(row, marketOutcome),
          ])
        )
      )?.[outcome];
    }

    return Number.isFinite(
      probability
    )
      ? `${
          (
            probability * 100
          ).toFixed(1)
        }%`
      : "–";
  }


  function getLeagueSummaryValue(
    row
  ) {
    if (
      leagueOddsDisplay ===
      "odds"
    ) {
      return "–";
    }

    const sum =
      getLeagueMarketProbabilitySum(
        row
      );

    if (!Number.isFinite(sum)) {
      return "–";
    }

    return leagueOddsDisplay ===
      "normalized"
      ? "100.0%"
      : `${
          (
            sum * 100
          ).toFixed(1)
        }%`;
  }


  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    agl: false,
  });

  const [mode, setMode] = useState("compile");
  const [forceCompile, setForceCompile] = useState(false);
  const weekEligibleIds = workspaceMode === "week"
    ? rows.filter(row => selectableDayFixture(row, mode, forceCompile)).map(row => row.id) : [];
  const activeSelection = workspaceMode === "week"
    ? selectionModel.filter(id => weekEligibleIds.includes(id)) : selectionModel;
  const selectVisibleEligible = () => workspaceMode === "week" && mode === "compile"
    ? weekCompilationSelection(rows, forceCompile) : automaticDaySelection(rows, mode, forceCompile);
  const [detailPanelExpandedRowIds, setDetailPanelExpandedRowIds] = useState(
    [],
  );

  const handleDetailPanelExpandedRowIdsChange = useCallback((newIds) => {
    setDetailPanelExpandedRowIds(
      newIds.length > 1 ? [newIds[newIds.length - 1]] : newIds,
    );
  }, []);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const handleModeChange = (event, newMode) => {
    if (newMode === null) return;
    setMode(newMode);
    setSelectionModel([]);
    setForceCompile(false);
  };

  function getIcon() {
    if (showStats !== "hidden") return <ExpandLessIcon />;
    else return <ExpandMoreIcon />;
  }

  useEffect(() => {
    if (workspaceMode === "league") return;
    let cancelled=false;
    setSelectionModel([]);setDetailPanelExpandedRowIds([]);
    let inFlight = false;
    let lastRefreshAt = 0;
    const refreshInterval = 30 * 60 * 1000;
    setRows([]);
    setFixturesUpdatedAt(null);
    setFixturesRefreshError(false);
    setColumnVisibilityModel({ agl: true });
    async function fetchData() {
      setFixturesRefreshing(true);
      var request;
      try {
        request = await fetchFromApi(
          `fetch-data-v3/fixtures/between/${
            readFrom
          }/${
            readTo
          }?include=scores;state;participants&per_page=50`,
        );
      } catch (e) {
        throw e;
      }

      if(!request.ok) throw new Error("FIXTURE_READ_FAILED");
      const response = await request.json();
      if(cancelled)return;
      if (response.message && response.message.startsWith("No result")) {
        setFixturesRefreshing(false);
        setRows([]);
        return { requestFixtures: [], response: { data: [] } };
      }

      let page = 2;
      while (response.pagination && response.pagination.has_more) {
        if(cancelled)return;
        try {
          const nextPage = await (
            await fetchFromApi(
              `fetch-data-v3/fixtures/between/${
                readFrom
              }/${
                readTo
              }?include=scores;state;participants&per_page=50&page=${page}`,
            )
          ).json();
          response.data = [...response.data, ...nextPage.data];
          response.pagination = nextPage.pagination;
          page++;
        } catch (e) {
          throw e;
        }
      }

      if (!Array.isArray(response.data)) throw new Error("FIXTURE_READ_FAILED");
      if (response.data.length === 0) {
        setRows([]);
        setFixturesRefreshing(false);
        return { requestFixtures: [], response: { data: [] } };
      }
      response.data=response.data.filter(f=>fixtureInRange(f,rangeStart,rangeEnd) && leagues.some(l=>Number(l.id)===Number(f.league_id)));
      if(cancelled)return;
      if(!response.data.length){setRows([]);setFixturesRefreshing(false);return;}
      const requestFixtures = response.data.map(
        ({ id, league_id, season_id, participants }) => ({
          season_id,
          id,
          league_id,
          localteam_id: participants?.find((p) => p.meta.location === "home")
            ?.id,
          localTeam: participants[0],
          visitorTeam: participants[1],
          visitorteam_id: participants?.find((p) => p.meta.location === "away")
            ?.id,
        }),
      );

      const details_response = await fetchViaPost(
        "get-details-for-fixtures",
        JSON.stringify({ fixtures: requestFixtures }),
      );
      const details = await details_response.json();
      if (!details_response.ok || !Array.isArray(details)) throw new Error(i18next.t("help.compilePreview.refreshError"));

      if(cancelled)return;
      var fixtures = response.data.map((e) => ({
        ...e,
        ...details.find((d) => d.id === e.id),
      }));

      let foundLeagues = leagues.map((a) => a.id);
      let cleanedFixtures = fixtures.filter((f) =>
        foundLeagues.includes(f.league_id),
      );
      fixtures = cleanedFixtures;

      const rows = fixtures.map((fixture) => {
        const league =
          leagues.find(
            (l) =>
              Number(l.id) === Number(fixture.league.id)
          ) ?? {};

        const germanDate = new Date(fixtureKickoff(fixture));

        fixture.scores.forEach((element) => {
          element.finish = fixture.state.state;
        });
        return {
          ...fixture,
          details: {
            date: germanDate,
            id: fixture.id,
          },
          league: {
            ...fixture.league,
            ...league,
          },
          user: { user },
          localTeam: {
            ...fixture.participants?.find((p) => p.meta.location === "home"),
            custom_name: fixture.localTeam?.data?.name,
          },
          visitorTeam: {
            ...fixture.participants?.find((p) => p.meta.location === "away"),
            custom_name: fixture.visitorTeam?.data?.name,
          },
          ...fixture.probs,
        };
      });
      if(cancelled)return;
      setRows(sortFixturesCanonical(rows));
      setFixturesRefreshing(false);
    }

    const refresh = async () => {
      if (cancelled || inFlight || !leagues?.length || fixturesRefreshBlocked.current) return;
      inFlight = true;
      lastRefreshAt = Date.now();
      try {
        await fetchData();
        if (!cancelled) {
          setFixturesUpdatedAt(new Date());
          setFixturesRefreshError(false);
        }
      } catch {
        if (!cancelled) setFixturesRefreshError(true);
      } finally {
        inFlight = false;
        if (!cancelled) setFixturesRefreshing(false);
      }
    };
    refreshFixturesRef.current = refresh;
    refresh();
    const timer = setInterval(() => {
      if (document.visibilityState === "visible" && Date.now() - lastRefreshAt >= refreshInterval) refresh();
    }, refreshInterval);
    const resume = () => { if (document.visibilityState === "visible" && Date.now() - lastRefreshAt >= refreshInterval) refresh(); };
    document.addEventListener("visibilitychange", resume);
    window.addEventListener("online", resume);
    return () => {
      cancelled = true;
      clearInterval(timer);
      document.removeEventListener("visibilitychange", resume);
      window.removeEventListener("online", resume);
      refreshFixturesRef.current = null;
    };
  }, [rangeStart, rangeEnd, readFrom, readTo, workspaceMode, leagues, user]);

  function showCompileError(message) {
    setMissingCompetitions([]);
    setPendingCompileIds([]);
    setModalTitle("Compile error");
    setModalText(message);
    setShowModal(true);
  }

  async function refreshCompiledFixtureDetails(fixtureIds) {
    const wanted = new Set(fixtureIds.map(Number));
    const sourceRows = [...rows, ...leagueRows];
    const fixtures = [];
    const seen = new Set();

    for (const row of sourceRows) {
      const id = Number(row.id);
      if (!wanted.has(id) || seen.has(id)) continue;
      const home = row.localTeam ?? row.homeTeam ?? row.local_team ?? row.home_team;
      const away = row.visitorTeam ?? row.awayTeam ?? row.visitor_team ?? row.away_team;
      fixtures.push({
        id,
        season_id: row.season_id ?? row.season?.id ?? row.league?.current_season_id,
        league_id: row.league_id,
        localteam_id: home?.id ?? home?.team_id ?? row.localteam_id ?? row.local_team_id,
        visitorteam_id: away?.id ?? away?.team_id ?? row.visitorteam_id ?? row.away_team_id,
      });
      seen.add(id);
    }

    if (!fixtures.length) return [];
    const detailGroups = await Promise.all(buildFixtureDetailRefreshRequests(fixtures).map(async (payload) => {
      const response = await fetchViaPost(
        "get-details-for-fixtures",
        JSON.stringify(payload),
      );
      const details = await response.json();
      if (!response.ok || !Array.isArray(details)) {
        throw new Error(i18next.t("help.compilePreview.refreshError"));
      }
      return details;
    }));
    const details = detailGroups.flat();
    setRows((currentRows) => mergeCompiledFixtureDetails(currentRows, details));
    setLeagueRows((currentRows) => mergeCompiledFixtureDetails(currentRows, details));
    return details;
  }

  async function compileFixtureIds(fixtureIds, skipMissing, options = {}) {
    if (evaluationRunningRef.current) {
      throw new Error(i18next.t("help.evaluationResult.runningWait"));
    }
    if (!fixtureIds.length) {
      setSelectionModel([]);
      return;
    }

    if (!options.previewFlow) setLoading(true);

    try {
      const SLICE_LENGTH = 40;
      const autoInitializedTeamIds = new Set();
      const compiledDetails = [];
      const failedIds = [];
      const successfulIds = [];

      for (let start = 0; start < fixtureIds.length; start += SLICE_LENGTH) {
        const slice = fixtureIds.slice(start, start + SLICE_LENGTH);

        const response = await readWorkflowResponse(
          await fetchViaPost(
            "compile-fixtures-in-selection",
            JSON.stringify({
              fixture_ids: slice,
              skip_missing: skipMissing,
              calculation_method: options.calculationMethod ?? "standard",
            }),
          ),
          {allowBatchFailure:true},
        );

        if (!response.success && response.code !== "COMPILATION_PARTIAL_FAILURE") {
          throw new Error("The selected fixtures could not be compiled.");
        }

        const outcome = compileBatchOutcome(response, slice);
        compiledDetails.push(...outcome.details);
        failedIds.push(...outcome.failed);
        successfulIds.push(...outcome.succeeded);
        if (outcome.details.length) {
          setRows(current => mergeCompiledFixtureDetails(current, outcome.details));
          setLeagueRows(current => mergeCompiledFixtureDetails(current, outcome.details));
        }

        for (const team of response.auto_initialized_teams ?? []) {
          const teamId = Number(team?.team_id);

          if (Number.isFinite(teamId)) {
            autoInitializedTeamIds.add(teamId);
          }
        }
      }

      if (compiledDetails.length) {
        setRows((currentRows) => mergeCompiledFixtureDetails(currentRows, compiledDetails));
        setLeagueRows((currentRows) => mergeCompiledFixtureDetails(currentRows, compiledDetails));
      }
      const compiledIds = new Set(compiledDetails.map((detail) => Number(detail.id)));
      const missingDetailIds = successfulIds.filter((id) => !compiledIds.has(Number(id)));
      if (missingDetailIds.length) {
        await refreshCompiledFixtureDetails(missingDetailIds);
      }

      if (statisticAllowed && successfulIds.length) {
        const statistics = await compileStatistics(successfulIds, [...rows, ...leagueRows], fetchViaPost);
        setStatisticCompileFailures(previous => {
          const next = {...previous};
          for (const id of statistics.refreshed) delete next[String(id)];
          for (const failure of statistics.failed) next[String(failure.id)] = true;
          return next;
        });
        setStatisticRefresh(value => value + 1);
        if (statistics.failed.length) {
          const ids = [...new Set([...failedIds, ...statistics.failed.map(f => f.id)])];
          setSelectionModel(ids);
          setLeagueSelectionModel(ids);
          throw new Error(`${i18next.language?.startsWith("de") ? "Statistikmodell nicht neu berechnet" : "Statistics model not recalculated"}: ${statistics.failed.map(f => `${f.id} (${f.error})`).join(", ")}`);
        }
      }

      if (failedIds.length) {
        setSelectionModel(failedIds);
        setLeagueSelectionModel(failedIds);
        throw new Error(`${successfulIds.length} compiled; ${failedIds.length} failed: ${failedIds.join(', ')}`);
      }
      setSelectionModel([]);
      setLeagueSelectionModel([]);
      setPendingCompileIds([]);
      setMissingCompetitions([]);

      if (autoInitializedTeamIds.size > 0) {
        await refreshLeagueStrengthRanking(
          leagueSeasonFixtures,
          selectedLeagueFixture?.stage_id
        );
        const teamNames = new Map();

        const sourceRows = [
          ...rows,
          ...leagueRows,
        ];

        for (const row of sourceRows) {
          const homeTeam =
            row.localTeam ??
            row.homeTeam ??
            row.local_team ??
            row.home_team;

          const awayTeam =
            row.visitorTeam ??
            row.awayTeam ??
            row.visitor_team ??
            row.away_team;

          const homeId = Number(
            homeTeam?.id ??
              homeTeam?.team_id ??
              row.local_team_id ??
              row.home_team_id,
          );

          const awayId = Number(
            awayTeam?.id ??
              awayTeam?.team_id ??
              row.visitor_team_id ??
              row.away_team_id,
          );

          if (
            autoInitializedTeamIds.has(homeId) &&
            !teamNames.has(homeId)
          ) {
            teamNames.set(
              homeId,
              homeTeam?.custom_name ??
                homeTeam?.name ??
                homeTeam?.team_name ??
                `Team ${homeId}`,
            );
          }

          if (
            autoInitializedTeamIds.has(awayId) &&
            !teamNames.has(awayId)
          ) {
            teamNames.set(
              awayId,
              awayTeam?.custom_name ??
                awayTeam?.name ??
                awayTeam?.team_name ??
                `Team ${awayId}`,
            );
          }
        }

        const names = [...autoInitializedTeamIds]
          .map(
            (teamId) =>
              teamNames.get(teamId) ?? `Team ${teamId}`,
          )
          .sort((a, b) => a.localeCompare(b));

        setModalTitle("Team Settings automatisch ergänzt");
        setModalText(
          `Die Team Settings wurden automatisch ergänzt. ` +
            `Neu aufgenommen: ${names.join(", ")}. ` +
            `Die Teams wurden zunächst mit neutralen Standardwerten ` +
            `initialisiert. Bitte die Team Settings prüfen und bei Bedarf ` +
            `nachjustieren.`,
        );
        setShowModal(true);
      }
    } catch (error) {
      if (options.throwOnError) throw error;
      showCompileError(
        error?.message || "The selected fixtures could not be compiled.",
      );
    } finally {
      if (!options.previewFlow) setLoading(false);
    }
  }

  function dataMaintenanceApplicationError(
    endpoint,
    response,
    result,
    fallback,
    responseType = "application_error",
  ) {
    const error = new Error(
      result?.message || (result?.reason ? `${fallback}: ${result.reason}` : fallback),
    );
    error.diagnosis = {
      success: false,
      endpoint,
      http_status: Number(response?.status) || null,
      content_type: response?.headers?.get?.("content-type") || null,
      response_type: responseType,
      reason_code: result?.reason_code || result?.reason || null,
      message: error.message,
    };
    return error;
  }

  async function requestDataMaintenance(endpoint, body) {
    const response = await fetchViaPost(endpoint, JSON.stringify(body));
    const result = await readDataMaintenanceResponse(response, endpoint);
    return { response, result };
  }

  async function diagnoseDataUpdateTarget(target) {
    const endpoint = "diagnose-my-data-update";
    const { response, result } = await requestDataMaintenance(endpoint, target);
    if (!result?.success) {
      throw dataMaintenanceApplicationError(
        endpoint,
        response,
        result,
        "Datenstatus konnte nicht geprüft werden.",
      );
    }
    return result;
  }

  function dataUpdateTargets(scope) {
    if (scope === "league" && leagueSeason?.is_current !== true) {
      return [];
    }
    return buildDataUpdateTargets(
      leagues,
      scope === "league"
        ? { league_id: selectedLeague?.id, season_id: leagueSeason?.id }
        : null,
    );
  }

  async function scanDataUpdateTargets(targets, onProgress) {
    const diagnoses = [];
    for (let index = 0; index < targets.length; index += 1) {
      const target = targets[index];
      onProgress?.({
        phase: "scan",
        current: index,
        total: targets.length,
        leagueName: target.league_name,
      });
      try {
        diagnoses.push(await diagnoseDataUpdateTarget(target));
      } catch (error) {
        diagnoses.push({
          success: false,
          ...target,
          ...dataMaintenanceIssueDetails(error),
        });
      }
      onProgress?.({
        phase: "scan",
        current: index + 1,
        total: targets.length,
        leagueName: target.league_name,
      });
    }
    return diagnoses;
  }

  async function previewMyDataUpdate(scope) {
    const targets = dataUpdateTargets(scope);
    setMyDataUpdate((current) => ({
      ...current,
      open: true,
      scope,
      running: true,
      stopping: false,
      result: null,
      preview: null,
      evaluateHistorical: null,
      foundationConfirmation: false,
      foundationRunning: false,
      progress: { phase: "scan", current: 0, total: targets.length, leagueName: "" },
    }));

    try {
      const setProgress = (progress) => setMyDataUpdate((current) => ({
        ...current,
        progress,
      }));
      const diagnoses = await scanDataUpdateTargets(targets, setProgress);
      const plan = buildDataUpdatePlan(diagnoses);
      if (scope === "global") {
        setGlobalDataUpdateAvailable(diagnoses.some(diagnosisHasDataMaintenanceOpportunity));
      }
      setMyDataUpdate((current) => ({
        ...current,
        running: false,
        progress: null,
        evaluateHistorical: plan.historicalGaps.length > 0 ? true : null,
        preview: { ...plan, seasons: diagnoses.filter((item) => item?.success && !item?.skipped && !item?.excluded) },
      }));
    } catch (error) {
      setMyDataUpdate((current) => ({ ...current, running: false, progress: null, result: { success: false, updated: 0, message: error?.message || String(error) } }));
    }
  }

  function openMyDataUpdate(scope = "global") {
    dataUpdateCancelRequested.current = false;
    setMyDataUpdate((current) => ({
      ...current,
      open: true,
      scope,
      running: false,
      stopping: false,
      progress: null,
      preview: null,
      result: null,
      evaluateHistorical: null,
      foundationConfirmation: false,
      foundationRunning: false,
    }));
  }

  async function applyMyDataFoundations() {
    const targets = (myDataUpdate.preview?.seasons || []).filter(
      (season) => season?.foundations?.foundation_status === "reference_available"
    );
    if (!targets.length || myDataUpdate.foundationRunning) return;
    setMyDataUpdate((current) => ({
      ...current,
      foundationRunning: true,
      foundationConfirmation: false,
      progress: { phase: "foundations", current: 0, total: targets.length, leagueName: "" },
    }));
    for (let index = 0; index < targets.length; index += 1) {
      const target = targets[index];
      setMyDataUpdate((current) => ({
        ...current,
        progress: { phase: "foundations", current: index, total: targets.length, leagueName: target.league_name || "" },
      }));
      try {
        await requestDataMaintenance("apply-my-data-foundations", {
          league_id: target.league_id,
          season_id: target.season_id,
        });
      } catch {
        // Die erneute Diagnose zeigt neutral, was weiterhin ergänzt werden kann.
      }
    }
    await previewMyDataUpdate("global");
  }

  async function applyMyDataUpdate() {
    const { scope, evaluateHistorical } = myDataUpdate;
    let plan = myDataUpdate.preview;
    if (!plan) return;
    dataUpdateCancelRequested.current = false;
    const targets = dataUpdateTargets(scope);
    setMyDataUpdate((current) => ({
      ...current,
      running: true,
      stopping: false,
      result: null,
    }));
    let completedCount = 0;
    try {
      const setProgress = (progress) => setMyDataUpdate((current) => ({ ...current, progress }));
      const foundationTargets = (plan.seasons || []).filter(season => season.foundations?.foundation_status === "reference_available");
      for (let index = 0; index < foundationTargets.length; index += 1) {
        const season = foundationTargets[index];
        setProgress({ current: index, total: foundationTargets.length, leagueName: season.league_name });
        try { await requestDataMaintenance("apply-my-data-foundations", { league_id: season.league_id, season_id: season.season_id }); }
        catch { /* The rescan reports the unresolved league; other leagues continue. */ }
      }
      if (foundationTargets.length) plan = buildDataUpdatePlan(await scanDataUpdateTargets(targets, setProgress));
      const execution = await executeDataUpdatePlan(plan, {
        inspectTask: async (task) => {
          const { result } = await requestDataMaintenance("get-my-data-maintenance-state", {
            fixture_id: task.fixture_id,
          });
          if (!result?.success) throw new Error("Der gespeicherte Verarbeitungsstand konnte nicht geprüft werden.");
          return result;
        },
        recordDiagnostic: async (diagnostic) => {
          await requestDataMaintenance("record-my-data-maintenance-diagnostic", diagnostic);
        },
        compileFixture: async (task) => {
          const endpoint = "compile-fixtures-in-selection";
          const { response, result } = await requestDataMaintenance(
            endpoint,
            {
              fixture_ids: [task.fixture_id],
              calculation_method: "standard",
            },
          );
          if (
            !result?.success ||
            result?.result?.some((item) => item?.success === false)
          ) {
            throw dataMaintenanceApplicationError(
              endpoint,
              response,
              result,
              "Kompilation fehlgeschlagen.",
            );
          }
        },
        maintainSeason: async (task) => {
          const endpoint = "maintain-my-data-season";
          const { response, result } = await requestDataMaintenance(endpoint, {
            league_id: task.league_id,
            season_id: task.season_id,
            fixture_id: task.fixture_id,
            postmatch_compiled: task.needs_compile === true,
            fixture_scoped: true,
            repair_only: task.repair_only === true,
          });
          if (
            !result?.success ||
            result?.expected_recorded !== true
          ) {
            throw dataMaintenanceApplicationError(
              endpoint,
              response,
              result,
              "Expected-/Should-Daten konnten nicht vollständig aktualisiert werden.",
              "incomplete_processing",
            );
          }
        },
        evaluateFixture: async (task) => {
          const endpoint = "update-parameters";
          const { response, result } = await requestDataMaintenance(
            endpoint,
            { fixture_ids: [task.fixture_id] },
          );
          const fixtureResult = completedEvaluationResult(result, task.fixture_id);
          if (!fixtureResult) {
            throw dataMaintenanceApplicationError(
              endpoint,
              response,
              result,
              "Evaluation wurde nicht vollständig abgeschlossen.",
              "incomplete_processing",
            );
          }
        },
        finalizeFixture: async (task) => {
          const endpoint = "finalize-my-data-fixture";
          const { response, result } = await requestDataMaintenance(endpoint, {
            fixture_id: task.fixture_id,
            league_id: task.league_id,
            season_id: task.season_id,
            season_maintained: true,
          });
          if (!result?.success || result?.finalized !== true || Number(result?.status) !== 5) {
            throw dataMaintenanceApplicationError(
              endpoint,
              response,
              result,
              "Fixture konnte nicht vollständig abgeschlossen werden.",
              "incomplete_processing",
            );
          }
        },
        evaluateHistorical,
        shouldStop: () => dataUpdateCancelRequested.current,
        onProgress: ({ current, total, task }) => setProgress({
          phase: "update",
          fixtureId: task?.fixture_id,
          current,
          total,
          leagueName: task?.league_name || "",
        }),
      });
      completedCount = execution.completed.length;

      const verification = execution.cancelled
        ? { safeTasks: [], historicalGaps: [], errors: [] }
        : buildDataUpdatePlan(await scanDataUpdateTargets(targets, setProgress));
      const stillAvailable =
        execution.cancelled || verification.safeTasks.length > 0 || verification.historicalGaps.length > 0 ||
        verification.seasons?.some((season) => season?.foundations?.foundation_status === "reference_available");
      if (scope === "global") setGlobalDataUpdateAvailable(stillAvailable);

      if (completedCount) {
        await refreshCompiledFixtureDetails(
          execution.completed.map((task) => task.fixture_id),
        );
      }
      const seasonFailed = execution.skipped.filter(
        (item) => item.reason === "season_failed",
      ).length;
      const cancelledOpen = execution.skipped.filter(
        (item) => item.reason === "cancelled",
      ).length;
      const issues = groupDataUpdateIssues([
        ...plan.errors,
        ...execution.failed,
        ...verification.errors,
      ]);
      const verificationIssues = [
        ...plan.errors,
        ...verification.errors,
      ];
      const isTechnicalIssue = (item) => [
        "timeout",
        "server_error",
        "invalid_response_type",
        "invalid_json",
        "request_error",
        "incomplete_processing",
      ].includes(item?.response_type) || Number(item?.http_status) >= 500;
      const technicalDiagnosisErrors = verificationIssues.filter(isTechnicalIssue).length;
      const technicalExecutionErrors = execution.failed.filter(isTechnicalIssue).length;
      setMyDataUpdate((current) => ({
        ...current,
        running: false,
        stopping: false,
        progress: null,
        result: {
          success: true,
          updated: completedCount,
          historicalGaps: verification.historicalGaps.length,
          cancelled: execution.cancelled === true,
          cancelledOpen,
          seasonFailed,
          technicalFailed: technicalExecutionErrors + technicalDiagnosisErrors,
          notCalculable:
            execution.failed.length - technicalExecutionErrors +
            verificationIssues.length - technicalDiagnosisErrors,
          unavailable: (verification.seasons || []).reduce((sum, season) => sum + Number(season.inventory_report?.summary?.not_applicable || 0) + Number(season.inventory_report?.summary?.not_reconstructable || 0), 0),
          notRequired: plan.notRequired?.length || 0,
          alreadyCompleted: (plan.seasons || []).reduce(
            (sum, season) => sum + Number(season?.finalized_fixtures || 0),
            0,
          ),
          remainingOpen: execution.cancelled
            ? cancelledOpen
            : verification.safeTasks.length + verification.historicalGaps.length,
          workBlocked: execution.failed.some((item) => item.chronology_blocking),
          issues,
        },
      }));
    } catch (error) {
      completedCount = error?.dataUpdateResult?.completed?.length ?? completedCount;
      setMyDataUpdate((current) => ({
        ...current,
        running: false,
        stopping: false,
        progress: null,
        result: {
          success: false,
          updated: completedCount,
          message: error?.message || String(error),
        },
      }));
      if (scope === "global") setGlobalDataUpdateAvailable(true);
    }
  }

  function cancelMyDataUpdate() {
    dataUpdateCancelRequested.current = true;
    setMyDataUpdate((current) => ({ ...current, stopping: true }));
  }

  useEffect(() => {
    if (!user?.id || !leagues?.length) return undefined;
    let cancelled = false;
    (async () => {
      try {
        for (const target of buildDataUpdateTargets(leagues)) {
          const result = await diagnoseDataUpdateTarget(target);
          if (diagnosisHasDataMaintenanceOpportunity(result)) {
            if (!cancelled) setGlobalDataUpdateAvailable(true);
            return;
          }
        }
        if (!cancelled) setGlobalDataUpdateAvailable(false);
      } catch {
        // Ein Diagnosefehler ist kein User-Warnzustand.
      }
    })();
    return () => { cancelled = true; };
  }, [user?.id, leagues]);

  useEffect(() => {
    onDataMaintenanceStatusChange(globalDataUpdateAvailable);
  }, [globalDataUpdateAvailable, onDataMaintenanceStatusChange]);

  useEffect(() => {
    if (dataMaintenanceRequest > 0) openMyDataUpdate("global");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataMaintenanceRequest]);

  async function openCompilePreview(
    fixtureIds,
    scope = "day",
    calculationMethod = "standard",
  ) {
    if (evaluationRunningRef.current) return;
    const ids = sortFixtureIdsCanonical(fixtureIds, [...rows, ...leagueRows]);
    if (!ids.length) return;
    setCompilePreview({
      open: true, fixtureIds: ids, fixtures: [], missingSeasons: [], scope,
      calculationMethod,
      loading: true, running: false, error: "", success: "",
    });
    try {
      const response = await (await fetchViaPost(
        "compile-fixtures-in-selection",
        JSON.stringify({
          fixture_ids: ids,
          check_only: true,
          calculation_method: calculationMethod,
        }),
      )).json();
      if (!response.success && !response.needs_team_settings) {
        throw new Error(i18next.t("help.compilePreview.checkError"));
      }
      setCompilePreview((current) => ({
        ...current,
        loading: false,
        fixtures: response.compile_preview ?? [],
        teams: response.compile_team_settings ?? [],
        missingSeasons: response.missing_seasons ?? [],
      }));
    } catch (error) {
      setCompilePreview((current) => ({
        ...current, loading: false,
        error: error?.message || i18next.t("help.compilePreview.checkError"),
      }));
    }
  }

  function handleCompileConfirm() {
    const rowsById = new Map(rows.map((row) => [Number(row.id), row]));
    return openCompilePreview(
      activeSelection.filter((id) =>
        !isFixtureEvaluationFinalized(rowsById.get(Number(id)))
      ),
      "day",
    );
  }

  async function confirmCompilePreview() {
    if (compileConfirmationPending.current || compilePreview.running) return;
    compileConfirmationPending.current = true;
    setCompilePreview((current) => ({ ...current, running: true, error: "" }));
    try {
      await compileFixtureIds(compilePreview.fixtureIds, false, {
        previewFlow: true,
        throwOnError: true,
        calculationMethod: compilePreview.calculationMethod,
      });
      setCompilePreview((current) => ({ ...current, running: false, open: false }));
    } catch (error) {
      setCompilePreview((current) => ({
        ...current, running: false,
        error: error?.message || i18next.t("help.compilePreview.error"),
      }));
    } finally {
      compileConfirmationPending.current = false;
    }
  }

  async function handleTakeFromWettopa() {
    const fixtureIds = [...pendingCompileIds];
    const competitions = [...missingCompetitions];

    setShowModal(false);
    setLoading(true);

    try {
      /*
       * Für jeden fehlenden Wettbewerb wird ausschließlich der
       * bereits vorhandene Backend-Endpunkt verwendet.
       */
      for (const competition of competitions) {
        const result = await (
          await fetchViaPost(
            "duplicate-from-created",
            JSON.stringify({
              season_id: competition.season_id,
              league_id: competition.league_id,
              league_name: competition.league_name,
            }),
          )
        ).json();

        if (result !== true) {
          throw new Error(
            `Wettopa-Settings für "${competition.league_name}" konnten nicht übernommen werden.`,
          );
        }
      }

      setLoading(false);
      await compileFixtureIds(fixtureIds, false);
    } catch (error) {
      showCompileError(
        error?.message || "The Wettopa settings could not be transferred.",
      );
    } finally {
      setLoading(false);
    }
  }

  async function handleCompileAvailable() {
    const fixtureIds = [...pendingCompileIds];

    setShowModal(false);
    await compileFixtureIds(fixtureIds, true);
  }

  function handleCompileCancel() {
    setShowModal(false);
    setMissingCompetitions([]);
    setPendingCompileIds([]);
  }


  /*
   * Vollwertiger Compile-Einstieg für die
   * neue Liga-Arbeitsliste.
   *
   * Verwendet dieselbe vorhandene Backend-
   * Vorprüfung wie die Tagesansicht.
   */
  async function handleLeagueCompileConfirm(
    fixtureIds
  ) {
    return openCompilePreview(fixtureIds, "league");
  }


  function getLeagueBettyStatus(status) {
    const statusMap = {
      [STATI["awaiting compilation"]]: {
        Icon: AwaitingCompilationIcon,
        translationKey: "awaitingCompilation",
      },
      [STATI.compiled]: {
        Icon: CompiledIcon,
        translationKey: "compiled",
      },
      [STATI["compilation confirmed"]]: {
        Icon: CompilationConfirmedIcon,
        translationKey: "compilationConfirmed",
      },
      [STATI["awaiting evaluation"]]: {
        Icon: AwaitingEvaluationIcon,
        translationKey: "awaitingEvaluation",
      },
      [STATI.finalized]: {
        Icon: EvaluationConfirmedIcon,
        translationKey: "evaluationConfirmed",
      },
    };

    return statusMap[status] || {
      Icon: HelpIcon,
      translationKey: "unknownStatus",
    };
  }


  function getLeagueEvaluableIds() {
    return leagueRows
      .filter(
        (row) =>
          canEvaluate(row) &&
          isFinishedFixture(row)
      )
      .map(
        (row) =>
          row.id
      );
  }


  function getLeagueSelectableIds() {
    if (mode === "evaluate") {
      return getLeagueEvaluableIds();
    }

    return leagueRows
      .filter(
        (row) => isNormalCompileCandidate(row, {
          forceCompile,
          preMatch: isPreMatchFixture(row),
        })
      )
      .map(
        (row) =>
          row.id
      );
  }


  async function handleRecompile(
    fixture_id,
    season_id,
    team_strength_1,
    team_strength_2,
    fixture_overrides = null,
    persist = true,
  ) {
    const response = await fetchViaPost(
      "compile-odds-for-one-fixture-from-team-strengths",
      JSON.stringify({
        fixture_id,
        season_id,
        team_strength_1,
        team_strength_2,
        fixture_overrides,
        postmatch: [...rows, ...leagueRows].some(fixture => Number(fixture.id) === Number(fixture_id) && (finishedFixture(fixture) || fixtureKickoff(fixture) <= Date.now())),
        persist,
      }),
    );
    const body = await readWorkflowResponse(response);
    if (!body.model_basis || !body.probs) throw new Error("INVALID_COMPILATION_RESPONSE");
    const compiledDetail = draftFixtureDetail(body, persist !== false);
    const applyCompiledValues =
      (currentRows) =>
        currentRows.map((e) => {
          if (e.id === fixture_id) {
            return {
              ...e,
              ...(compiledDetail || {}),
            };
          }

          return e;
        });

    setRows(
      (currentRows) =>
        applyCompiledValues(
          currentRows
        )
    );

    /*
     * Dieselbe Neuberechnung muss in der
     * Liga-Arbeitsansicht sofort sichtbar sein.
     */
    setLeagueRows(
      (currentRows) =>
        applyCompiledValues(
          currentRows
        )
    );
    return body;
  }

  function resetLocalFixtureDraft(fixtureId, baselineRow) {
    const restore = (currentRows) => restoreFixtureDraftRows(currentRows, fixtureId, baselineRow);
    setRows(restore);
    setLeagueRows(restore);
  }

  function getEvaluationCompetitionName(
    leagueId,
    seasonId,
  ) {
    const matchingRow =
      rows.find(
        (row) =>
          Number(
            row?.league_id ??
            row?.league?.id
          ) === Number(leagueId) &&
          Number(
            row?.season_id
          ) === Number(seasonId)
      );

    const matchingLeague =
      leagues.find(
        (league) =>
          Number(league?.id) ===
          Number(leagueId)
      );

    return (
      matchingRow?.league?.name ??
      matchingLeague?.name ??
      "Unbekannter Wettbewerb"
    );
  }




  async function handleCreateMissingEvaluationTables() {
    if (!evaluationResult) {
      return;
    }

    const tasks = [
      ...(
        evaluationResult.missingExpectedTables || []
      ).map((item) => ({
        ...item,
        table: "Expected Table",
        existsField: "expected_table_exists",
        possibleField: "expected_possible",
        mode: null,
      })),

      ...(
        evaluationResult.missingShouldTables || []
      ).map((item) => ({
        ...item,
        table: "Should Table",
        existsField: "should_table_exists",
        possibleField: "should_possible",
        mode: "build_should",
      })),
    ];

    if (!tasks.length) {
      return;
    }

    setCreatingMissingTables(true);
    setMissingTablesActionResult(null);

    const expectedCreated = new Set();
    const shouldCreated = new Set();
    const unavailable = [];
    const errors = [];

    const itemKey = (item) =>
      `${item.league_id}:${item.season_id}`;

    const itemName = (item) =>
      item.league_name ||
      getEvaluationCompetitionName(
        item.league_id,
        item.season_id
      );

    const loadState = async (item) => {
      const response = await fetchViaPost(
        "build-user-season-stats",
        JSON.stringify({
          mode: "load",
          league_id: Number(item.league_id),
          season_id: Number(item.season_id),
        })
      );

      const result = await response.json();

      if (!response.ok || !result?.success) {
        throw new Error(
          result?.message ||
          "Tabellenstatus konnte nicht geprüft werden."
        );
      }

      return result;
    };

    try {
      for (const item of tasks) {
        try {
          const before = await loadState(item);

          if (before[item.existsField]) {
            if (item.table === "Expected Table") {
              expectedCreated.add(itemKey(item));
            } else {
              shouldCreated.add(itemKey(item));
            }

            continue;
          }

          if (!before[item.possibleField]) {
            unavailable.push({
              table: item.table,
              league_name: itemName(item),
              message:
                item.table === "Expected Table"
                  ? "Season Parameters oder Team Strengths fehlen."
                  : "Noch keine vollständig nutzbaren Match Statistics vorhanden.",
            });

            continue;
          }

          const body = {
            league_id: Number(item.league_id),
            season_id: Number(item.season_id),
          };

          if (item.mode) {
            body.mode = item.mode;
          }

          const response = await fetchViaPost(
            "build-user-season-stats",
            JSON.stringify(body)
          );

          const result = await response.json();

          if (!response.ok || !result?.success) {
            throw new Error(
              result?.message ||
              `${item.table} konnte nicht angelegt werden.`
            );
          }

          /*
           * Eine erfolgreiche API-Antwort genügt nicht.
           * Erst der anschließende LOAD bestätigt,
           * dass die Tabelle wirklich gespeichert wurde.
           */
          const after = await loadState(item);

          if (!after[item.existsField]) {
            throw new Error(
              "Die Tabelle wurde nach dem Aufbau nicht gespeichert gefunden."
            );
          }

          if (item.table === "Expected Table") {
            expectedCreated.add(itemKey(item));
          } else {
            shouldCreated.add(itemKey(item));
          }
        } catch (error) {
          errors.push({
            table: item.table,
            league_name: itemName(item),
            message:
              error?.message ||
              "Die Tabelle konnte nicht angelegt werden.",
          });
        }
      }

      /*
       * Nur Tabellen entfernen, deren Existenz
       * tatsächlich bestätigt wurde.
       */
      setEvaluationResult((current) => {
        if (!current) {
          return current;
        }

        return {
          ...current,

          missingExpectedTables:
            current.missingExpectedTables.filter(
              (item) =>
                !expectedCreated.has(itemKey(item))
            ),

          missingShouldTables:
            current.missingShouldTables.filter(
              (item) =>
                !shouldCreated.has(itemKey(item))
            ),
        };
      });

      setMissingTablesActionResult({
        expectedCreated: expectedCreated.size,
        shouldCreated: shouldCreated.size,
        unavailable,
        errors,
      });
    } finally {
      setCreatingMissingTables(false);
    }
  }


  async function handleEvaluateConfirm(fixtureIdsOverride = null) {
    if (evaluationRunningRef.current) return;
    const requestedFixtureIds =
      fixtureIdsOverride
        ? [...fixtureIdsOverride]
        : [...selectionModel];

    const currentRowsById =
      new Map(
        [...rows, ...leagueRows].map(
          (row) => [Number(row?.id), row]
        )
      );

    const fixtureIds =
      requestedFixtureIds.filter(
        (fixtureId) => {
          const row =
            currentRowsById.get(
              Number(fixtureId)
            );

          return Boolean(
            row &&
            canEvaluate(row) &&
            isFinishedFixture(row) &&
            row.status !==
              STATI.finalized
          );
        }
      );

    if (!fixtureIds.length) {
      return;
    }

    evaluationRunningRef.current = true;

    const totalFixtures =
      fixtureIds.length;

    /*
     * Die normale Fullscreen-loading-Anzeige
     * verwenden wir während Evaluate bewusst
     * NICHT mehr.
     *
     * Sonst würde unsere Fortschrittsanzeige
     * gar nicht sichtbar sein.
     */
    setLoading(false);

    setEvaluateProgress({
      current: 0,
      total: totalFixtures,
      expectedUpdated: 0,
      shouldUpdated: 0,
      shouldStatisticsComplete: 0,
      shouldStatisticsIncomplete: 0,
      auxiliaryErrors: 0,
    });

    let processed = 0;

    try {
      const SLICE_LENGTH = 10;

      let expectedUpdated = 0;
      let shouldUpdated = 0;

      let shouldStatisticsComplete = 0;
      let shouldStatisticsIncomplete = 0;

      let auxiliaryErrors = 0;

      const missingExpectedTables =
        new Map();

      const missingShouldTables =
        new Map();


      for (
        let start = 0;
        start < fixtureIds.length;
        start += SLICE_LENGTH
      ) {
        const slice =
          fixtureIds.slice(
            start,
            start + SLICE_LENGTH,
          );

        if (!slice.length) {
          continue;
        }


        setEvaluateProgress((current) => ({
          ...(current || {}),
          block: Math.floor(start / SLICE_LENGTH) + 1,
          blocks: Math.ceil(totalFixtures / SLICE_LENGTH),
          inFlight: slice.length,
          current:
            processed,
          total:
            totalFixtures,
          expectedUpdated,
          shouldUpdated,
          shouldStatisticsComplete,
          shouldStatisticsIncomplete,
          auxiliaryErrors,
        }));


        const response =
          await fetchViaPost(
            "update-parameters",
            JSON.stringify({
              fixture_ids:
                slice,
            }),
          );

        let body;

        try {
          body =
            await response.json();
        } catch {
          throw new Error(
            `Evaluation fehlgeschlagen: Serverantwort konnte nicht gelesen werden (HTTP ${response.status}).`,
          );
        }


        if (
          !response.ok ||
          !body?.success
        ) {
          const fixtureInfo =
            body?.fixture_id
              ? ` Fixture ${body.fixture_id}.`
              : "";

          throw new Error(
            `${
              body?.message ||
              `Evaluation fehlgeschlagen (HTTP ${response.status}).`
            }${fixtureInfo}${body?.partial ? ` Bereits verarbeitet: ${body.processed_fixture_ids?.length || 0}; offen: ${body.remaining_fixture_ids?.length || 0}.` : ""}`,
          );
        }


        /*
         * Backend-Summary dieses Batches
         * in die Gesamtanzeige übernehmen.
         */
        const summary =
          body?.summary ||
          {};

        expectedUpdated +=
          Number(
            summary?.expected_updated ||
            0
          );

        shouldUpdated +=
          Number(
            summary?.should_updated ||
            0
          );

        shouldStatisticsComplete +=
          Number(
            summary
              ?.should_statistics_complete ||
            0
          );

        shouldStatisticsIncomplete +=
          Number(
            summary
              ?.should_statistics_incomplete ||
            0
          );

        auxiliaryErrors +=
          Number(
            summary?.auxiliary_errors ||
            0
          );


        for (
          const item of
          summary
            ?.missing_expected_tables ||
          []
        ) {
          const leagueId =
            Number(
              item?.league_id
            );

          const seasonId =
            Number(
              item?.season_id
            );

          if (
            Number.isFinite(
              leagueId
            ) &&
            Number.isFinite(
              seasonId
            )
          ) {
            missingExpectedTables.set(
              `${leagueId}:${seasonId}`,
              {
                league_id:
                  leagueId,

                season_id:
                  seasonId,

                league_name:
                  getEvaluationCompetitionName(
                    leagueId,
                    seasonId
                  ),
              },
            );
          }
        }


        for (
          const item of
          summary
            ?.missing_should_tables ||
          []
        ) {
          const leagueId =
            Number(
              item?.league_id
            );

          const seasonId =
            Number(
              item?.season_id
            );

          if (
            Number.isFinite(
              leagueId
            ) &&
            Number.isFinite(
              seasonId
            )
          ) {
            missingShouldTables.set(
              `${leagueId}:${seasonId}`,
              {
                league_id:
                  leagueId,

                season_id:
                  seasonId,

                league_name:
                  getEvaluationCompetitionName(
                    leagueId,
                    seasonId
                  ),
              },
            );
          }
        }


        processed +=
          slice.length;


        const markEvaluated =
          (currentRows) =>
            currentRows.map((row) => {
              if (
                slice.includes(
                  row.id
                )
              ) {
                return {
                  ...row,
                  status:
                    STATI.finalized,
                };
              }

              return row;
            });

        setRows(markEvaluated);
        setLeagueRows(markEvaluated);


        setEvaluateProgress({
          current:
            processed,

          total:
            totalFixtures,

          expectedUpdated,
          shouldUpdated,

          shouldStatisticsComplete,
          shouldStatisticsIncomplete,

          auxiliaryErrors,
        });
      }


      setSelectionModel([]);
      setLeagueSelectionModel([]);

      await refreshCompiledFixtureDetails(fixtureIds);

      /*
       * Nach der Evaluation Actual, Expected und
       * Should aus den gespeicherten Saisonwerten
       * neu laden.
       */
      if (
        workspaceMode === "league" &&
        selectedLeague?.id &&
        leagueSeason?.id
      ) {
        try {
          const refreshedComparison = await refreshLeagueEvaluationData({
            fixtureIds,
            seasonFixtures: leagueSeasonFixtures,
            fetchComparison: () => fetchLeagueSeasonComparison(
              selectedLeague.id,
              leagueSeason.id
            ),
            refreshFixtureDetails: refreshCompiledFixtureDetails,
          });

          setLeagueSeasonComparison(
            refreshedComparison
          );
        } catch (error) {
          console.warn(
            "[League season comparison refresh]",
            error
          );
        }
      }

      /*
       * Strukturiertes Ergebnis der Evaluation.
       *
       * Diese Daten bilden die Grundlage für:
       * - die kurze Abschlussmeldung,
       * - "Details anzeigen",
       * - die spätere Nachrüstung fehlender Tabellen.
       *
       * Die Liga-/Saison-Kombinationen bleiben bewusst
       * vollständig erhalten und werden nicht nur als
       * Anzahl in einen Meldungstext geschrieben.
       */
      setEvaluationResult({
        processed,
        expectedUpdated,
        shouldUpdated,
        shouldStatisticsComplete,
        shouldStatisticsIncomplete,
        auxiliaryErrors,

        missingExpectedTables: [
          ...missingExpectedTables.values(),
        ],

        missingShouldTables: [
          ...missingShouldTables.values(),
        ],
      });

      setShowEvaluationDetails(false);


      const messages = [
        `${processed} Fixture${
          processed === 1
            ? ""
            : "s"
        } erfolgreich evaluiert.`,
      ];


      if (
        expectedUpdated > 0
      ) {
        messages.push(
          `Expected Table: ${expectedUpdated} Update${
            expectedUpdated === 1
              ? ""
              : "s"
          }.`,
        );
      }


      if (
        shouldUpdated > 0 ||
        shouldStatisticsIncomplete > 0
      ) {
        messages.push(
          `Should Table: ${shouldUpdated} Update${
            shouldUpdated === 1
              ? ""
              : "s"
          }.`,
        );
      }


      if (
        shouldStatisticsIncomplete > 0
      ) {
        messages.push(
          `${shouldStatisticsIncomplete} Fixture${
            shouldStatisticsIncomplete === 1
              ? ""
              : "s"
          } ohne vollständige Statistics; Should dort nicht aktualisiert.`,
        );
      }


      if (
        missingExpectedTables.size > 0
      ) {
        messages.push(
          `Für ${missingExpectedTables.size} Wettbewerb${
            missingExpectedTables.size === 1
              ? ""
              : "e"
          } fehlt eine Expected Table.`,
        );
      }


      if (
        missingShouldTables.size > 0
      ) {
        messages.push(
          `Für ${missingShouldTables.size} Wettbewerb${
            missingShouldTables.size === 1
              ? ""
              : "e"
          } fehlt eine Should Table.`,
        );
      }


      if (
        auxiliaryErrors > 0
      ) {
        messages.push(
          `${auxiliaryErrors} zusätzliche Table-Stats-Aktualisierung${
            auxiliaryErrors === 1
              ? ""
              : "en"
          } konnte nicht vollständig durchgeführt werden.`,
        );
      }


      setModalTitle(
        i18next.t(
          "help.evaluationResult.title"
        ),
      );

      setModalText(
        messages.join(" "),
      );

      setShowModal(true);
    } catch (error) {
      console.error(
        "[Evaluation]",
        error,
      );

      let verified = [];
      try {
        verified = await refreshCompiledFixtureDetails(fixtureIds) || [];
      } catch (refreshError) {
        console.warn("[Evaluation status refresh]", refreshError);
      }
      const complete = verified.filter((item) => item?.evaluation_finalized === true).length;
      const partial = verified.filter((item) =>
        item?.evaluation_finalized !== true &&
        ["prepared", "model_applied", "statistics_applied"].includes(item?.evaluation_operation_state)
      ).length;
      const untouched = Math.max(0, verified.length - complete - partial);

      setModalTitle(i18next.t("help.evaluationResult.failedTitle"));
      setModalText(evaluationFailureText(i18next.t.bind(i18next), error, { complete, partial, untouched, verified: verified.length > 0 }));

      setShowModal(true);
    } finally {
      evaluationRunningRef.current = false;
      setEvaluateProgress(null);
    }
  }


  function fixtureDetailsButton(row) {
    const label = i18next.language.startsWith("en")
      ? "Open match details · also available by double-clicking the fixture"
      : "Details zum Spiel öffnen · auch per Doppelklick auf die Paarung";
    return <Tooltip title={label}><IconButton size="small" aria-label={label}
      onDoubleClick={event => event.stopPropagation()}
      onClick={event => { event.stopPropagation(); setFixtureDetailsRow(row); }}>
      <SearchIcon fontSize="small" />
    </IconButton></Tooltip>;
  }

  function getDetailPanelContent(props) {
    const fixtureLeague = leagues.find(l => Number(l.id) === Number(props.row?.league_id));
    return (<Box>
      {fixtureLeague && <Button disabled={evaluationRunning || leagueSettingsDirty} onClick={() => {
        pendingAdminFixture.current = props.row.id;
        setRequestedLeagueSeasonId(props.row.season_id);
        setRequestedLeagueRoundId(props.row.round_id || null);
        setSelectedLeague(fixtureLeague);
        setWorkspaceMode("league");
      }}>{i18next.t("help.start.openLeague")} · <LeagueDisplay league={fixtureLeague} compact /></Button>}
      <FixtureDetails
        {...props}
        initialWorkspace={props.directAnalysis && getUserAccessLevel(user) === "admin" ? "experiment" : "legacy"}
        onWorkspaceClose={() => setFixtureDetailsRow(null)}
        handleRecompile={handleRecompile}
        onDraftReset={resetLocalFixtureDraft}
        indicationThreshold={leagueIndicationThreshold}
        user={user}
        strengthsRevision={effectiveTeamStrengthsRevision}
      />
      </Box>
    );
  }

  if (
    loading &&
    !evaluateProgress
  )
    return (
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );

  function leadZero(num) {
    return String(num).padStart(2, "0");
  }

  const renderLeagueHeader = (admin = false) => (<>
          <Paper
            className={admin ? "al-selectors" : undefined}
            variant="outlined"
            sx={{
              p: 1,
              display: "grid",
              gridTemplateColumns: {
                xs: "minmax(0, 1fr)",
                lg: "minmax(0, 1fr)",
              },
              columnGap: 1,
              rowGap: 0.75,
              alignItems: "start",
            }}
          >
            {/*
             * Kompakter Liga-Selektor.
             *
             * Im normalen Arbeiten bleibt nur die
             * aktuelle Liga sichtbar. Die vollständige
             * Auswahl öffnet sich als eigenes Panel und
             * verbraucht deshalb keine dauerhafte Breite.
             */}
            <Box
              sx={{
                gridColumn: {
                  xs: "1",
                  lg: "1",
                },
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                gap: 0.5,
                minWidth: 0,
                width: 300,
                maxWidth: "100%",
              }}
            >
              <Button
                variant="outlined"
                disabled={evaluationRunning || leagueSettingsDirty}
              onClick={(event) => {
                setLeagueSelectorAnchor(
                  event.currentTarget
                );
                setLeagueSearch("");
              }}
              sx={{
                width: "100%",
                minWidth: 0,
                maxWidth: "none",
                height: 38,
                justifyContent:
                  "space-between",
                px: 1.1,
                py: 0.45,
                textTransform: "none",
                borderColor: "divider",
                bgcolor: "background.paper",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  minWidth: 0,
                  width: "100%",
                }}
              >
                {selectedLeague &&
                  getLeagueFlag(
                    selectedLeague
                  ) && (
                    <Box
                      component="img"
                      alt={
                        selectedLeague
                          ?.country
                          ?.name || ""
                      }
                      src={`data:image/svg+xml;utf8,${encodeURIComponent(
                        getLeagueFlag(
                          selectedLeague
                        )
                      )}`}
                      sx={{
                        width: 24,
                        height: 17,
                        objectFit: "cover",
                        flex: "0 0 auto",
                      }}
                    />
                  )}

                <Typography
                  variant="body2"
                  noWrap
                  sx={{
                    fontWeight: 800,
                    flex: 1,
                    textAlign: "left",
                  }}
                >
                  {selectedLeague
                    ?.name ||
                    "Liga auswählen"}
                </Typography>

                {selectedLeague
                  ?.image_path && (
                  <Box
                    component="img"
                    src={
                      selectedLeague
                        .image_path
                    }
                    alt=""
                    sx={{
                      width: 28,
                      height: 28,
                      objectFit:
                        "contain",
                      flex:
                        "0 0 auto",
                    }}
                  />
                )}

                <Typography
                  component="span"
                  sx={{
                    fontSize:
                      "0.85rem",
                    color:
                      "text.secondary",
                    ml: 0.25,
                  }}
                >
                  ▼
                </Typography>
              </Box>
              </Button>

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns:
                    "34px minmax(0, 1fr) 34px",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <Button
                  variant="outlined"
                  disabled={
                    evaluationRunning || leagueSettingsDirty ||
                    leagueLoading ||
                    leagueSeasonIndex <= 0
                  }
                  onClick={() =>
                    selectNeighbourLeagueSeason(
                      -1
                    )
                  }
                  title={i18next.t(
                    "help.leagueWorkspace.previousSeason"
                  )}
                  aria-label={i18next.t(
                    "help.leagueWorkspace.previousSeason"
                  )}
                  sx={{
                    minWidth: 34,
                    height: 34,
                    px: 0.5,
                    py: 0.25,
                    fontWeight: 900,
                  }}
                >
                  ‹
                </Button>

                <TextField
                  select
                  size="small"
                  value={
                    leagueSeason?.id ??
                    ""
                  }
                  disabled={
                    evaluationRunning || leagueSettingsDirty ||
                    leagueLoading ||
                    !leagueSeasons.length
                  }
                  onChange={(event) => {
                    setRequestedLeagueSeasonId(
                      Number(
                        event.target.value
                      )
                    );

                    setRequestedLeagueRoundId(
                      null
                    );
                  }}
                  SelectProps={{
                    native: true,
                  }}
                  inputProps={{
                    "aria-label":
                      i18next.t(
                        "help.leagueWorkspace.season"
                      ),
                  }}
                  sx={{
                    minWidth: 0,
                    "& .MuiInputBase-root": {
                      height: 34,
                      fontSize: "0.8rem",
                      fontWeight: 800,
                    },
                  }}
                >
                  {!leagueSeason && (
                    <option value="">
                      {i18next.t(
                        "help.leagueWorkspace.season"
                      )}
                    </option>
                  )}

                  {leagueSeasons.map(
                    (season) => (
                      <option
                        key={season.id}
                        value={season.id}
                      >
                        {
                          season.name ||
                          season.id
                        }
                      </option>
                    )
                  )}
                </TextField>

                <Button
                  variant="outlined"
                  disabled={
                    evaluationRunning || leagueSettingsDirty ||
                    leagueLoading ||
                    leagueSeasonIndex < 0 ||
                    leagueSeasonIndex >=
                      leagueSeasons.length - 1
                  }
                  onClick={() =>
                    selectNeighbourLeagueSeason(
                      1
                    )
                  }
                  title={i18next.t(
                    "help.leagueWorkspace.nextSeason"
                  )}
                  aria-label={i18next.t(
                    "help.leagueWorkspace.nextSeason"
                  )}
                  sx={{
                    minWidth: 34,
                    height: 34,
                    px: 0.5,
                    py: 0.25,
                    fontWeight: 900,
                  }}
                >
                  ›
                </Button>
              </Box>

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns:
                    "34px minmax(0, 1fr) 34px",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <Button
                  variant="outlined"
                  disabled={
                    evaluationRunning || leagueSettingsDirty ||
                    leagueLoading ||
                    leagueRoundIndex <= 0
                  }
                  onClick={() =>
                    selectNeighbourLeagueRound(
                      -1
                    )
                  }
                  title="Vorheriger Spieltag"
                  aria-label="Vorheriger Spieltag"
                  sx={{
                    minWidth: 34,
                    height: 34,
                    px: 0.5,
                    py: 0.25,
                    fontWeight: 900,
                  }}
                >
                  ‹
                </Button>

                <TextField
                  select
                  size="small"
                  value={
                    leagueRound?.id ??
                    ""
                  }
                  disabled={
                    evaluationRunning || leagueSettingsDirty ||
                    leagueLoading ||
                    !leagueRounds.length
                  }
                  onChange={(event) =>
                    setRequestedLeagueRoundId(
                      Number(
                        event.target.value
                      )
                    )
                  }
                  SelectProps={{
                    native: true,
                  }}
                  sx={{
                    minWidth: 0,
                    "& .MuiInputBase-root": {
                      height: 34,
                      fontSize: "0.8rem",
                      fontWeight: 800,
                    },
                  }}
                >
                  {!leagueRound && (
                    <option value="">
                      Spieltag
                    </option>
                  )}

                  {leagueRounds.map(
                    (round) => (
                      <option
                        key={round.id}
                        value={round.id}
                      >
                        Spieltag {round.name}
                      </option>
                    )
                  )}
                </TextField>

                <Button
                  variant="outlined"
                  disabled={
                    evaluationRunning || leagueSettingsDirty ||
                    leagueLoading ||
                    leagueRoundIndex < 0 ||
                    leagueRoundIndex >=
                      leagueRounds.length - 1
                  }
                  onClick={() =>
                    selectNeighbourLeagueRound(
                      1
                    )
                  }
                  title="Nächster Spieltag"
                  aria-label="Nächster Spieltag"
                  sx={{
                    minWidth: 34,
                    height: 34,
                    px: 0.5,
                    py: 0.25,
                    fontWeight: 900,
                  }}
                >
                  ›
                </Button>
              </Box>
            </Box>


            {!admin && <>
            <Box
              sx={{
                gridColumn: {
                  xs: "1",
                  lg: "1",
                },
                gridRow: {
                  xs: "auto",
                  lg: "2",
                },
                minWidth: 0,
                alignSelf: "start",
                overflow: "hidden",
              }}
            >
              <LeagueSeasonComparison
                data={
                  leagueSeasonComparison
                }
              />
            </Box>

            <Box sx={{
              gridColumn: "1",
              gridRow: "auto",
              minWidth: 0,
              overflow: "hidden",
            }}>
              <details className="league-table-disclosure"><summary>{i18next.t("help.start.leagueTable")}</summary>
              <CompactLeagueTable
                onTeamSettings={() => setReviewLeagueSettings({...selectedLeague, current_season_id:leagueSeason?.id})}
                displayTeamNames={new Map(leagueRows.flatMap(f=>[f.localTeam,f.visitorTeam]).filter(Boolean).map(t=>[Number(t.id),t.custom_name || t.name]))}
                seasonId={leagueSeason?.id}
                teamLogos={new Map(leagueSeasonFixtures.flatMap(fixture => (fixture.participants || []).map(team => [Number(team.id), team.image_path])))}
                standingRules={leagueSeasonBase?.standing_rules?.items || []}
                transitionItems={leagueSeasonBase?.team_transitions?.items || []}
                actualRows={leagueSeasonBase?.actual_table || []}
                expectedRows={leagueSeasonComparison?.record?.expected_table || []}
                shouldRows={leagueSeasonComparison?.record?.should_table || []}
                selectedTeamIds={[
                  selectedLeagueFixture?.localTeam?.id,
                  selectedLeagueFixture?.visitorTeam?.id,
                ].filter(Boolean)}
              />
              </details>
            </Box>


            </>}
            <Popover
              open={
                leagueSelectorOpen
              }
              anchorEl={
                leagueSelectorAnchor
              }
              onClose={() => {
                setLeagueSelectorAnchor(
                  null
                );
                setLeagueSearch("");
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              PaperProps={{
                sx: {
                  mt: 0.5,
                  width: 430,
                  maxWidth:
                    "calc(100vw - 32px)",
                  maxHeight:
                    "72vh",
                  overflow:
                    "hidden",
                  display:
                    "flex",
                  flexDirection:
                    "column",
                  borderRadius: 1.5,
                },
              }}
            >
              <Box
                sx={{
                  p: 1.5,
                  borderBottom:
                    "1px solid",
                  borderColor:
                    "divider",
                  bgcolor:
                    "background.paper",
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontWeight: 900,
                    mb: 1,
                  }}
                >
                  Liga auswählen
                </Typography>

                <TextField
                  autoFocus
                  fullWidth
                  size="small"
                  value={
                    leagueSearch
                  }
                  onChange={(event) =>
                    setLeagueSearch(
                      event.target.value
                    )
                  }
                  placeholder="Liga oder Land suchen …"
                />
              </Box>


              <Box
                sx={{
                  overflowY: "auto",
                  py: 0.5,
                }}
              >
                {Object.entries(
                  groupedLeagueOptions
                ).map(
                  ([
                    country,
                    countryLeagues,
                  ]) => (
                    <Box
                      key={
                        country
                      }
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          display:
                            "block",
                          px: 1.5,
                          pt: 1.25,
                          pb: 0.4,
                          color:
                            "text.secondary",
                          fontWeight:
                            900,
                          textTransform:
                            "uppercase",
                          letterSpacing:
                            "0.04em",
                        }}
                      >
                        {country}
                      </Typography>

                      {countryLeagues.map(
                        (
                          leagueItem
                        ) => {
                          const allowed =
                            isLeagueAccessible(
                              leagueItem
                            );

                          const active =
                            Number(
                              leagueItem.id
                            ) ===
                            Number(
                              selectedLeague
                                ?.id
                            );

                          const flag =
                            getLeagueFlag(
                              leagueItem
                            );

                          return (
                            <Button
                              key={
                                leagueItem.id
                              }
                              fullWidth
                              disabled={
                                !allowed
                              }
                              onClick={() => {
                                setSelectedLeague(
                                  leagueItem
                                );

                                setRequestedLeagueSeasonId(
                                  null
                                );

                                setRequestedLeagueRoundId(
                                  null
                                );

                                setLeagueSeasons(
                                  []
                                );

                                setLeagueRounds(
                                  []
                                );

                                sessionStorage.setItem(
                                  "fixturesSelectedLeagueId",
                                  String(
                                    leagueItem.id
                                  )
                                );

                                setLeagueSelectorAnchor(
                                  null
                                );
                                setLeagueSearch(
                                  ""
                                );
                              }}
                              sx={{
                                minHeight:
                                  46,
                                justifyContent:
                                  "flex-start",
                                borderRadius:
                                  0,
                                px: 1.5,
                                py: 0.5,
                                textTransform:
                                  "none",
                                opacity:
                                  allowed
                                    ? 1
                                    : 0.48,
                                bgcolor:
                                  active
                                    ? "action.selected"
                                    : "transparent",
                                "&:hover":
                                  {
                                    bgcolor:
                                      active
                                        ? "action.selected"
                                        : "action.hover",
                                  },
                              }}
                            >
                              <Box
                                sx={{
                                  display:
                                    "grid",
                                  gridTemplateColumns:
                                    "30px minmax(0, 1fr) auto 40px",
                                  alignItems:
                                    "center",
                                  gap: 1,
                                  width:
                                    "100%",
                                }}
                              >
                                <Box
                                  sx={{
                                    width:
                                      28,
                                    display:
                                      "flex",
                                    justifyContent:
                                      "center",
                                  }}
                                >
                                  {flag ? (
                                    <Box
                                      component="img"
                                      alt={
                                        country
                                      }
                                      src={`data:image/svg+xml;utf8,${encodeURIComponent(
                                        flag
                                      )}`}
                                      sx={{
                                        width:
                                          24,
                                        height:
                                          17,
                                        objectFit:
                                          "cover",
                                      }}
                                    />
                                  ) : (
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      •
                                    </Typography>
                                  )}
                                </Box>

                                <Typography
                                  variant="body2"
                                  noWrap
                                  sx={{
                                    textAlign:
                                      "left",
                                    fontWeight:
                                      active
                                        ? 900
                                        : 600,
                                  }}
                                >
                                  {
                                    leagueItem.name
                                  }
                                </Typography>

                                {!allowed && (
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{
                                      whiteSpace:
                                        "nowrap",
                                      fontWeight:
                                        700,
                                    }}
                                  >
                                    🔒 Silver
                                  </Typography>
                                )}

                                <Box
                                  sx={{
                                    width:
                                      38,
                                    height:
                                      32,
                                    display:
                                      "flex",
                                    alignItems:
                                      "center",
                                    justifyContent:
                                      "center",
                                  }}
                                >
                                  {leagueItem
                                    ?.image_path && (
                                    <Box
                                      component="img"
                                      src={
                                        leagueItem
                                          .image_path
                                      }
                                      alt=""
                                      sx={{
                                        maxWidth:
                                          34,
                                        maxHeight:
                                          28,
                                        objectFit:
                                          "contain",
                                      }}
                                    />
                                  )}
                                </Box>
                              </Box>
                            </Button>
                          );
                        }
                      )}
                    </Box>
                  )
                )}

                {!visibleLeagueOptions.length && (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      p: 2,
                    }}
                  >
                    Keine passende Liga gefunden.
                  </Typography>
                )}
              </Box>
            </Popover>
          </Paper>


  </>);
  const leaguePairings = (<>
          <Paper
            variant="outlined"
            sx={{
              overflowX: "auto",
            }}
          >
            {/*
             * Compile-Arbeitsleiste.
             * Bewusst kompakt und direkt an der
             * Fixture-Liste.
             */}
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                flexWrap: "wrap",
                gap: 0.75,
                px: 1,
                py: 0.7,
                borderBottom:
                  "1px solid",
                borderColor:
                  "divider",
              }}
            >
              <ToggleButtonGroup
                exclusive
                size="small"
                value={mode}
                onChange={(event, newMode) => {
                  if (!newMode) {
                    return;
                  }

                  setMode(newMode);
                  setLeagueSelectionModel([]);
                  setForceCompile(false);
                }}
                aria-label={i18next.t(
                  "help.leagueWorkspace.workMode"
                )}
              >
                <ToggleButton
                  value="compile"
                  disabled={evaluationRunning || leagueSettingsDirty}
                  sx={{
                    px: 1,
                    py: 0.25,
                    textTransform: "none",
                    fontWeight: 700,
                  }}
                >
                  {i18next.t(
                    "help.leagueWorkspace.compile"
                  )}
                </ToggleButton>

                <ToggleButton
                  value="evaluate"
                  disabled={evaluationRunning || leagueSettingsDirty}
                  sx={{
                    px: 1,
                    py: 0.25,
                    textTransform: "none",
                    fontWeight: 700,
                  }}
                >
                  {i18next.t(
                    "help.leagueWorkspace.evaluate"
                  )}
                </ToggleButton>
              </ToggleButtonGroup>

              {mode === "compile" && (
                <Button
                  size="small"
                  variant={
                    forceCompile
                      ? "contained"
                      : "outlined"
                  }
                  color={
                    forceCompile
                      ? "warning"
                      : "inherit"
                  }
                  disabled={evaluationRunning || leagueSettingsDirty}
                  title={
                    forceCompile
                      ? i18next.t(
                          "help.leagueWorkspace.retroCompileActive"
                        )
                      : i18next.t(
                          "help.leagueWorkspace.retroCompile"
                        )
                  }
                  aria-label={
                    forceCompile
                      ? i18next.t(
                          "help.leagueWorkspace.retroCompileActive"
                        )
                      : i18next.t(
                          "help.leagueWorkspace.retroCompile"
                        )
                  }
                  onClick={() => {
                    setForceCompile(
                      (current) =>
                        !current
                    );
                    setLeagueSelectionModel([]);
                  }}
                  sx={{
                    minWidth: 34,
                    px: 0.75,
                    py: 0.25,
                  }}
                >
                  <HistoryIcon fontSize="small" />
                  <Box sx={{ ml: 0.5 }}>
                    {i18next.t("help.leagueWorkspace.retroCompileShort")}
                  </Box>
                </Button>
              )}

              <Button
                size="small"
                variant="contained"
                title={i18next.t(
                  mode === "compile"
                    ? "help.leagueWorkspace.runCompile"
                    : "help.leagueWorkspace.runEvaluate"
                )}
                aria-label={i18next.t(
                  mode === "compile"
                    ? "help.leagueWorkspace.runCompile"
                    : "help.leagueWorkspace.runEvaluate"
                )}
                disabled={
                  !leagueSelectionModel.length || leagueSettingsDirty ||
                  Boolean(evaluateProgress)
                }
                onClick={() => {
                  if (mode === "evaluate") {
                    handleEvaluateConfirm(
                      leagueSelectionModel
                    );
                    return;
                  }

                  handleLeagueCompileConfirm(
                    leagueSelectionModel
                  );
                }}
                sx={{
                  minWidth: 34,
                  px: 1,
                  py: 0.25,
                }}
              >
                <PlayArrowIcon fontSize="small" />
                <Box sx={{ ml: 0.5 }}>
                  {i18next.t(
                    mode === "compile"
                      ? "help.leagueWorkspace.runCompileShort"
                      : "help.leagueWorkspace.runEvaluateShort"
                  )}
                </Box>
              </Button>

              <Box
                sx={{
                  ml: "auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  flex: "1 1 760px",
                  minWidth: 0,
                  minHeight: 32,
                  flexWrap: "wrap",
                  gap: 0.55,
                }}
              >
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    fontWeight: 800,
                  }}
                >
                  {i18next.t(
                    "help.leagueAnalysis.analysis"
                  )}
                </Typography>

                <ToggleButtonGroup
                  exclusive
                  size="small"
                  value={
                    leagueAnalysisPhase
                  }
                  onChange={(
                    event,
                    value
                  ) => {
                    if (!value) {
                      return;
                    }

                    const nextPhase = getManualLeagueAnalysisPhase(
                      leagueAnalysisPhase,
                      value,
                      leagueRows
                    );
                    setLeagueAnalysisPhase(nextPhase);

                    if (
                      hasLeaguePostMatchComparison &&
                      nextPhase === "post"
                    ) {
                      setLeaguePostMatchView(
                        "comparison"
                      );
                    } else {
                      setLeaguePostMatchView(
                        "market"
                      );
                    }
                  }}
                >
                  <ToggleButton
                    value="pre"
                    sx={{
                      px: 1.25,
                      py: 0.25,
                      textTransform:
                        "none",
                      fontWeight: 700,
                    }}
                  >
                    Pre-Match
                  </ToggleButton>

                  <ToggleButton
                    value="post"
                    disabled={
                      !leagueRows.some(
                        (row) =>
                          isFinishedFixture(
                            row
                          )
                      )
                    }
                    sx={{
                      px: 1.25,
                      py: 0.25,
                      textTransform:
                        "none",
                      fontWeight: 700,
                    }}
                  >
                    Post-Match
                  </ToggleButton>
                </ToggleButtonGroup>

                {hasLeaguePostMatchComparison &&
                  leagueAnalysisPhase === "post" && (
                  <>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ ml: 0.35, fontWeight: 800 }}
                    >
                      {i18next.t(
                        "help.leagueAnalysis.evaluation"
                      )}
                    </Typography>
                    <TextField
                      select
                      size="small"
                      value={leaguePostMatchView}
                      title={i18next.t("help.leagueAnalysis.marketAnalysisTooltip")}
                      onChange={(event) =>
                        setLeaguePostMatchView(
                          event.target.value
                        )
                      }
                      SelectProps={{ native: true }}
                      sx={{
                        width: 180,
                        "& .MuiInputBase-root": {
                          height: 30,
                          fontSize: "0.78rem",
                        },
                      }}
                    >
                      <option value="market">
                        {i18next.t(
                          "help.leagueAnalysis.marketAnalysis"
                        )}
                      </option>
                      <option value="comparison">
                        {i18next.t(
                          "help.leagueAnalysis.postMatchGoals"
                        )}
                      </option>
                    </TextField>
                  </>
                )}

                {leagueAnalysisPhase === "post" &&
                  leaguePostMatchView === "market" &&
                  ["1x2", "over-under", "btts"].includes(leagueAnalysisView) && (
                    <TextField
                      select
                      size="small"
                      value={leaguePostMarketMode}
                      onChange={(event) => setLeaguePostMarketMode(event.target.value)}
                      SelectProps={{ native: true }}
                      title={i18next.t("help.leagueAnalysis.perfectTipsTooltip")}
                      sx={{ width: 180, "& .MuiInputBase-root": { height: 30, fontSize: "0.76rem" } }}
                    >
                      <option value="odds">
                        {i18next.t("help.leagueAnalysis.oddsComparison")}
                      </option>
                      <option value="perfect-tips">
                        {i18next.t("help.leagueAnalysis.perfectTips.summary")}
                      </option>
                    </TextField>
                  )}

                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    ml: 0.35,
                    fontWeight: 800,
                  }}
                >
                  {i18next.t(
                    "help.leagueAnalysis.market"
                  )}
                </Typography>

                <TextField
                  select
                  size="small"
                  value={
                    leagueAnalysisView
                  }
                  title={i18next.t("help.leagueAnalysis.marketAnalysisTooltip")}
                  onChange={(event) => {
                    const nextView = event.target.value;
                    setLeagueAnalysisView(nextView);
                    if (nextView === "asian-handicap") {
                      setLeagueHandicapLine(
                        getDefaultHandicapSelection(leagueRows)
                      );
                      setLeagueHandicapLineOverrides({});
                    }
                  }}
                  SelectProps={{
                    native: true,
                  }}
                  sx={{
                    width: 142,
                    "& .MuiInputBase-root":
                      {
                        height: 30,
                        fontSize:
                          "0.78rem",
                      },
                  }}
                >
                  <option value="1x2">
                    1X2
                  </option>

                  <option value="over-under">
                    Over / Under
                  </option>

                  <option value="double-chance">Double Chance</option>
                  <option value="btts">
                    Both Teams to Score
                  </option>

                  {hasLeaguePostMatchComparison && (
                    <option value="asian-handicap">
                      Asian Handicap
                    </option>
                  )}

                </TextField>

                {hasLeaguePostMatchComparison &&
                  leagueAnalysisView === "over-under" && (
                  <TextField
                    select
                    size="small"
                    value={leagueGoalLine}
                    onChange={(event) => {
                      setLeagueGoalLine(event.target.value);
                      setLeagueGoalLineOverrides({});
                    }}
                    SelectProps={{ native: true }}
                    sx={{
                      width: 176,
                      "& .MuiInputBase-root": {
                        height: 30,
                        fontSize: "0.76rem",
                      },
                    }}
                  >
                    <option value="2.50">2,5 · Standard-Line</option>
                    <option value="betty-balanced">betty Most Balanced</option>
                    <option value="market-balanced">Markt Most Balanced</option>
                    {getGlobalGoalLines()
                      .filter((line) => line !== "2.50")
                      .map((line) => (
                        <option key={line} value={line}>
                          Eigene Line · {Number(line).toLocaleString("de-DE")}
                        </option>
                      ))}
                  </TextField>
                )}

                {hasLeaguePostMatchComparison &&
                  leagueAnalysisView === "asian-handicap" && (
                  <TextField
                    select
                    size="small"
                    value={leagueHandicapLine}
                    onChange={(event) => {
                      setLeagueHandicapLine(event.target.value);
                      setLeagueHandicapLineOverrides({});
                    }}
                    SelectProps={{ native: true }}
                    sx={{
                      width: 142,
                      "& .MuiInputBase-root": {
                        height: 30,
                        fontSize: "0.76rem",
                      },
                    }}
                  >
                    {BALANCED_LINE_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                    {getGlobalHandicapLines().map((line) => (
                      <option key={line} value={line}>
                        {formatAsianHandicapLine(line)}
                      </option>
                    ))}
                  </TextField>
                )}

                {showPerfectTipsMarket && (
                  <TextField
                    select
                    size="small"
                    value={leaguePerfectTipsDisplay}
                    onChange={(event) =>
                      setLeaguePerfectTipsDisplay(event.target.value)
                    }
                    SelectProps={{ native: true }}
                    inputProps={{
                      "aria-label": i18next.t(
                        "help.leagueAnalysis.perfectTips.display"
                      ),
                    }}
                    sx={{
                      width: 142,
                      "& .MuiInputBase-root": {
                        height: 30,
                        fontSize: "0.76rem",
                      },
                    }}
                  >
                    <option value="probabilities">
                      {i18next.t("help.leagueAnalysis.perfectTips.probabilities")}
                    </option>
                    <option value="stake">
                      {i18next.t("help.leagueAnalysis.perfectTips.stake")}
                    </option>
                    <option value="payout">
                      {i18next.t("help.leagueAnalysis.perfectTips.payout")}
                    </option>
                  </TextField>
                )}

                {["1x2", "over-under", "asian-handicap", "btts", "double-chance"].includes(
                  leagueAnalysisView
                ) && !showPerfectTipsMarket && (
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{
                      ml: 0.35,
                      fontWeight: 800,
                    }}
                  >
                    {i18next.t(
                      "help.leagueAnalysis.view"
                    )}
                  </Typography>
                )}

                {["1x2", "over-under", "asian-handicap", "btts", "double-chance"].includes(
                  leagueAnalysisView
                ) && !showPerfectTipsMarket && (
                  <TextField
                    select
                    size="small"
                    value={
                      leagueOddsDisplay
                    }
                    onChange={(event) =>
                      setLeagueOddsDisplay(
                        event.target.value
                      )
                    }
                    SelectProps={{
                      native: true,
                    }}
                    sx={{
                      width: 92,
                      "& .MuiInputBase-root": {
                        height: 30,
                        fontSize:
                          "0.76rem",
                      },
                    }}
                  >
                    <option value="odds">
                      {i18next.t(
                        "help.leagueAnalysis.odds"
                      )}
                    </option>

                    <option value="implied">
                      {i18next.t(
                        "help.leagueAnalysis.implied"
                      )}
                    </option>

                    <option value="normalized">
                      100 %
                    </option>
                  </TextField>
                )}

                {["1x2", "over-under", "asian-handicap", "btts", "double-chance"].includes(
                  leagueAnalysisView
                ) && (
                  <ToggleButtonGroup
                    exclusive
                    size="small"
                    value={
                      leagueMarketBasis
                    }
                    onChange={(
                      event,
                      value
                    ) => {
                      if (!value) {
                        return;
                      }

                      setLeagueMarketBasis(
                        value
                      );
                    }}
                  >
                    <ToggleButton
                      value="average"
                      title={i18next.t(
                        "help.leagueAnalysis.averageTitle"
                      )}
                      sx={{
                        minWidth: 38,
                        px: 0.8,
                        py: 0.25,
                        textTransform:
                          "none",
                        fontWeight:
                          800,
                      }}
                    >
                      Ø
                    </ToggleButton>

                    <ToggleButton
                      value="highest"
                      title={i18next.t(
                        "help.leagueAnalysis.maximumTitle"
                      )}
                      sx={{
                        minWidth: 48,
                        px: 0.8,
                        py: 0.25,
                        textTransform:
                          "none",
                        fontWeight:
                          800,
                      }}
                    >
                      Max
                    </ToggleButton>
                  </ToggleButtonGroup>
                )}

                {["1x2", "over-under", "asian-handicap"].includes(
                  leagueAnalysisView
                ) && (
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{
                      ml: 0.35,
                      fontWeight: 800,
                    }}
                  >
                    {i18next.t(
                      "help.leagueAnalysis.indicationFrom"
                    )}
                  </Typography>
                )}

                {["1x2", "over-under", "asian-handicap"].includes(
                  leagueAnalysisView
                ) && (
                  <TextField
                    size="small"
                    type="number"
                    value={
                      leagueIndicationThreshold
                    }
                    onChange={(event) => {
                      const value = Number(
                        event.target.value
                      );

                      setLeagueIndicationThreshold(
                        Number.isFinite(value)
                          ? Math.max(
                              0,
                              Math.min(
                                100,
                                value
                              )
                            )
                          : 0
                      );
                    }}
                    inputProps={{
                      min: 0,
                      max: 100,
                      step: 1,
                      "aria-label":
                        i18next.t(
                          "help.leagueAnalysis.thresholdAria"
                        ),
                    }}
                    sx={{
                      width: 58,
                      "& .MuiInputBase-root": {
                        height: 30,
                        fontSize:
                          "0.76rem",
                      },
                      "& input": {
                        py: 0.4,
                        px: 0.75,
                        textAlign:
                          "right",
                      },
                    }}
                  />
                )}

                {leagueAnalysisView ===
                  "1x2" && (
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{
                      ml: -0.25,
                      fontWeight: 800,
                    }}
                  >
                    %
                  </Typography>
                )}

                {["1x2", "over-under", "asian-handicap"].includes(
                  leagueAnalysisView
                ) &&
                  leagueMarketLoading && (
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      noWrap
                    >
                      {i18next.t(
                        "help.leagueAnalysis.marketLoading"
                      )}
                    </Typography>
                  )}
              </Box>
            </Box>


            <Box
              sx={{
                display: "grid",
                gridTemplateColumns:
                  LEAGUE_WORKSPACE_GRID_COLUMNS,
                minWidth: 0,
                width: "100%",
                boxSizing: "border-box",
                "& > *": { minWidth: 0 },
                gap: 0.35,
                alignItems: "center",
                px: 1,
                py: 0.45,
                borderBottom:
                  "1px solid",
                borderColor:
                  "divider",
                bgcolor:
                  "action.hover",
              }}
            >
              <Checkbox
                size="small"
                checked={
                  getLeagueSelectableIds()
                    .length > 0 &&
                  leagueSelectionModel
                    .length ===
                    getLeagueSelectableIds()
                      .length
                }
                indeterminate={
                  leagueSelectionModel
                    .length > 0 &&
                  leagueSelectionModel
                    .length <
                    getLeagueSelectableIds()
                      .length
                }
                disabled={
                  !getLeagueSelectableIds()
                    .length
                }
                onChange={(
                  event
                ) => {
                  setLeagueSelectionModel(
                    event.target
                      .checked
                      ? getLeagueSelectableIds()
                      : []
                  );
                }}
                sx={{
                  p: 0.25,
                }}
              />

              <Typography
                variant="caption"
                sx={{
                  fontWeight: 800,
                }}
              >
                {i18next.t(
                  "help.leagueAnalysis.status"
                )}
              </Typography>

              <Typography
                variant="caption"
                sx={{
                  fontWeight: 800,
                }}
              >
                {i18next.t(
                  "help.leagueAnalysis.kickoff"
                )}
              </Typography>

              <Typography
                variant="caption"
                sx={{
                  fontWeight: 800,
                }}
              >
                {i18next.t(
                  "help.leagueAnalysis.match"
                )}
              </Typography>

              <Box
                aria-hidden="true"
                sx={{
                  minWidth: 0,
                }}
              />

              <Typography
                variant="caption"
                sx={{
                  fontWeight: 800,
                }}
              >
                {i18next.t(
                  "help.leagueAnalysis.result"
                )}
              </Typography>

              <Box
                sx={{
                  minWidth: 0,
                }}
              >
                {showLeaguePostMatchComparison ? (
                  <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr)) 110px", gap: 0.5 }}>
                    {["expected", "should", "performanceIndex"].map(
                      (key) => (
                        <Typography
                          key={key}
                          variant="caption"
                          align="center"
                          title={i18next.t(`help.leagueAnalysis.${key}Tooltip`)}
                          sx={{ fontWeight: 900 }}
                        >
                          {i18next.t(
                            `help.leagueAnalysis.matchdayComparison.${key}`
                          )}
                        </Typography>
                      )
                    )}
                  </Box>
                ) : showPerfectTipsMarket ? (
                  <PerfectTipsHeader
                    display={leaguePerfectTipsDisplay}
                    outcomes={getLeagueAnalysisOutcomes()}
                    market={i18next.t(
                      leagueAnalysisView === "over-under"
                        ? "help.compilePreview.markets.goalLines"
                        : leagueAnalysisView === "btts"
                          ? "help.compilePreview.markets.btts"
                          : "help.compilePreview.markets.oneXTwo"
                    )}
                  />
                ) : ["1x2", "over-under", "asian-handicap", "btts", "double-chance"].includes(
                  leagueAnalysisView
                ) ? (
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns:
                        leagueAnalysisView === "1x2"
                          ? leagueOddsDisplay === "odds"
                            ? LEAGUE_1X2_ODDS_GRID_COLUMNS
                            : LEAGUE_1X2_COMPARISON_GRID_COLUMNS
                          : ["over-under", "asian-handicap"].includes(leagueAnalysisView)
                            ? "72px repeat(3, minmax(0, 1fr))"
                            : "repeat(3, minmax(0, 1fr))",
                      gap: 0.5,
                      justifyContent:
                        leagueAnalysisView === "1x2"
                          ? "start"
                          : "stretch",
                    }}
                  >
                    {["over-under", "asian-handicap"].includes(leagueAnalysisView) && (
                      <Typography variant="caption" align="center" sx={{ fontWeight: 900 }}>
                        Line
                      </Typography>
                    )}
                    {[
                      {
                        key: "betty",
                        label: i18next.language?.startsWith("de") ? "Ergebnisbasiert" : "Result based",
                      },
                      {
                        key: "statistic",
                        label: i18next.language?.startsWith("de") ? "Statistikbasiert" : "Statistics based",
                      },
                      {
                        key: "market",
                        label:
                          leagueMarketBasis === "average"
                            ? (i18next.language?.startsWith("de") ? "Markt Ø" : "Market avg")
                            : (i18next.language?.startsWith("de") ? "Markt Max" : "Market best"),
                      },
                    ].map((group) => (
                      <Box
                        key={group.key}
                        sx={{
                          minWidth: 0,
                          textAlign: "center",
                          px: 0.45,
                          py: 0.25,
                          borderLeft:
                            group.key === "market"
                              ? "2px solid"
                              : "1px solid",
                          borderRight:
                            "1px solid",
                          borderTop:
                            "1px solid",
                          borderColor:
                            group.key === "betty"
                              ? "rgba(126, 53, 88, 0.30)"
                              : "divider",
                          bgcolor:
                            group.key === "betty"
                              ? "rgba(126, 53, 88, 0.085)"
                              : "rgba(0, 0, 0, 0.035)",
                          borderRadius:
                            "5px 5px 0 0",
                        }}
                      >
                        <Typography
                          variant="caption"
                          display="block"
                          sx={{
                            mb: 0.15,
                            fontWeight: 900,
                          }}
                        >
                          {group.label}
                        </Typography>

                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns:
                              `repeat(${getLeagueAnalysisOutcomes().length}, minmax(0, 1fr))`,
                            gap: 0.25,
                          }}
                        >
                          {getLeagueAnalysisOutcomes().map(
                            (outcome) => (
                              <Typography
                                key={outcome}
                                variant="caption"
                                sx={{
                                  fontWeight: 900,
                                }}
                              >
                                {outcome === "over"
                                  ? "Over"
                                  : outcome === "under"
                                    ? "Under"
                                    : outcome === "home"
                                      ? "Home"
                                      : outcome === "away"
                                        ? "Away"
                                    : outcome === "yes"
                                      ? "Yes"
                                      : outcome === "no"
                                        ? "No"
                                        : outcome}
                              </Typography>
                            )
                          )}
                        </Box>
                      </Box>
                    ))}

                    {leagueAnalysisView === "1x2" &&
                    leagueOddsDisplay !== "odds" && <Box
                      sx={{
                        minWidth: 0,
                        textAlign:
                          "center",
                        px: 0.25,
                        py: 0.25,
                      }}
                    >
                      <Typography
                        variant="caption"
                        display="block"
                        sx={{
                          fontWeight: 900,
                        }}
                      >
                        {i18next.t(
                          "help.leagueAnalysis.sum"
                        )}
                      </Typography>
                    </Box>}
                  </Box>
                ) : hasLeaguePostMatchComparison &&
                  leagueAnalysisView === "asian-handicap" ? (
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                      gap: 0.5,
                    }}
                  >
                    {["Home", "Away"].map((label) => (
                      <Typography
                        key={label}
                        variant="caption"
                        align="center"
                        sx={{ fontWeight: 900 }}
                      >
                        {label}
                      </Typography>
                    ))}
                  </Box>
                ) : (
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: 800,
                    }}
                  >
                    {getAnalysisLabel()}
                  </Typography>
                )}
              </Box>
            </Box>

            {leagueLoading && (
              <Box
                sx={{
                  py: 3,
                  px: 2,
                }}
              >
                <LinearProgress />

                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{
                    display:
                      "block",
                    mt: 1,
                  }}
                >
                  Liga und aktueller Spieltag werden geladen …
                </Typography>
              </Box>
            )}

            {!leagueLoading &&
              leagueError && (
                <Typography
                  sx={{
                    p: 2,
                  }}
                >
                  {leagueError}
                </Typography>
              )}

            {!leagueLoading &&
              !leagueError &&
              leagueRows.map(
                (row) => {
                  const selected =
                    Number(
                      row.id
                    ) ===
                    Number(
                      selectedLeagueFixture
                        ?.id
                    );

                  const date =
                    getGermanFixtureDate(
                      row.starting_at
                    );

                  const result =
                    getFixtureResultText(
                      row
                    );

                  const {
                    Icon: BettyStatusIcon,
                    translationKey:
                      bettyStatusTranslationKey,
                  } = getLeagueBettyStatus(
                    row.status
                  );

                  const processing = fixtureProcessingStatus({...row, statistic_prediction:leagueStatisticModels[String(row.id)], statistic_read_status:statisticReadErrors[`${row.league_id}:${row.season_id}`] ? "error" : leagueStatisticStatus});
                  const live =
                    isLiveFixture(
                      row
                    );

                  const liveLabel =
                    live
                      ? getFixtureStatusLabel(
                          row
                        )
                      : "";

                  const selectable =
                    getLeagueSelectableIds()
                      .some(
                        (id) =>
                          Number(id) ===
                          Number(row.id)
                      );

                  const checked =
                    leagueSelectionModel
                      .some(
                        (id) =>
                          Number(id) ===
                          Number(row.id)
                      );

                  return (
                    <Box
                      key={row.id}
                      onDoubleClick={()=>setFixtureDetailsRow(row)}
                      onClick={() =>
                        setSelectedLeagueFixtureId(
                          row.id
                        )
                      }
                      sx={{
                        display:
                          "grid",
                        gridTemplateColumns:
                          LEAGUE_WORKSPACE_GRID_COLUMNS,
                minWidth: 0,
                width: "100%",
                boxSizing: "border-box",
                "& > *": { minWidth: 0 },
                        gap: 0.35,
                        alignItems:
                          "center",
                        px: 1,
                        py: 0.38,
                        cursor:
                          "pointer",
                        borderBottom:
                          "1px solid",
                        borderColor:
                          "divider",
                        bgcolor:
                          selected
                            ? "action.selected"
                            : "transparent",
                        "&:hover": {
                          bgcolor:
                            selected
                              ? "action.selected"
                              : "action.hover",
                        },
                      }}
                    >
                      <Checkbox
                        size="small"
                        checked={
                          checked
                        }
                        disabled={
                          !selectable
                        }
                        onClick={(
                          event
                        ) =>
                          event
                            .stopPropagation()
                        }
                        onChange={(
                          event
                        ) => {
                          const isChecked =
                            event.target
                              .checked;

                          setLeagueSelectionModel(
                            (
                              current
                            ) => {
                              if (
                                isChecked
                              ) {
                                return [
                                  ...new Set([
                                    ...current,
                                    row.id,
                                  ]),
                                ];
                              }

                              return current.filter(
                                (id) =>
                                  Number(
                                    id
                                  ) !==
                                  Number(
                                    row.id
                                  )
                              );
                            }
                          );
                        }}
                        sx={{
                          p: 0.25,
                        }}
                      />

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          minWidth: 0,
                          color:
                            "text.secondary",
                        }}
                      >
                        <span title={processing.label} aria-label={processing.label}>
                          {processing.code === "complete" ? "✓" : processing.code === "compiled" ? "K" : "!"}
                        </span>
                      </Box>

                      <Typography
                        variant="body2"
                        noWrap
                        sx={{
                          fontVariantNumeric:
                            "tabular-nums",
                        }}
                      >
                        {!date
                          ? "–"
                          : date.toLocaleString(
                              undefined,
                              {
                                weekday:
                                  "short",
                                day:
                                  "2-digit",
                                month:
                                  "2-digit",
                                hour:
                                  "2-digit",
                                minute:
                                  "2-digit",
                              }
                            )}
                      </Typography>

                      <Box sx={{display:"flex",alignItems:"center",minWidth:0}}>
                      <Typography
                        variant="body2"
                        noWrap
                        title={
                          `${
                            row
                              ?.localTeam
                              ?.custom_name ||
                            row
                              ?.localTeam
                              ?.name ||
                            "–"
                          } – ${
                            row
                              ?.visitorTeam
                              ?.custom_name ||
                            row
                              ?.visitorTeam
                              ?.name ||
                            "–"
                          } · Fixture-ID ${row.id}`
                        }
                        sx={{
                          minWidth: 0, flex:1,
                          overflow: "hidden",
                          textOverflow:
                            "ellipsis",
                          fontWeight:
                            selected
                              ? 800
                              : 600,
                        }}
                      >
                        {row
                          ?.localTeam
                          ?.custom_name ||
                          row
                            ?.localTeam
                            ?.name ||
                          "–"}
                        {" – "}
                        {row
                          ?.visitorTeam
                          ?.custom_name ||
                          row
                            ?.visitorTeam
                            ?.name ||
                          "–"}
                      </Typography>{fixtureDetailsButton(row)}<Button size="small" sx={{flexShrink:0,minWidth:52,fontSize:11}} onClick={event=>{event.stopPropagation();setTeamAnalysisFixture(row);}}>{i18next.language.startsWith("en")?"Analyze":"Analyse"}</Button></Box>

                      <Typography
                        variant="caption"
                        noWrap
                        align="center"
                        sx={{
                          minWidth: 0,
                          color:
                            "error.main",
                          fontSize:
                            "0.7rem",
                          lineHeight: 1,
                          fontWeight: 900,
                          fontVariantNumeric:
                            "tabular-nums",
                        }}
                      >
                        {liveLabel}
                      </Typography>

                      <Box
                        sx={{
                          minWidth: 0,
                          display: "flex",
                          alignItems: "center",
                          gap: 0.25,
                        }}
                      >
                        <Typography
                          variant="body2"
                          noWrap
                          sx={{ minWidth: 0, flex: 1, fontVariantNumeric: "tabular-nums", fontWeight: 600 }}
                        >
                          {result || ""}
                        </Typography>
                        <AsianHandicapMenu row={row} statsOnly />
                      </Box>

                      <Box
                        sx={{
                          minWidth: 0,
                        }}
                      >
                        {showLeaguePostMatchComparison ? (
                          <LeagueFixtureGoalAnalysis
                            fixture={row}
                          />
                        ) : showPerfectTipsMarket ? (
                          <PerfectTipsFixtureValues
                            result={getPerfectTipsResult(row)}
                            display={leaguePerfectTipsDisplay}
                          />
                        ) : ["1x2", "over-under", "asian-handicap", "btts", "double-chance"].includes(
                          leagueAnalysisView
                        ) ? (
                          (() => {
                            const outcomes =
                              getLeagueAnalysisOutcomes();
                            const displayedLine =
                              leagueAnalysisView === "over-under"
                                ? getSelectedGoalLine(row)
                                : leagueAnalysisView === "asian-handicap"
                                  ? getSelectedHandicapLine(row)
                                  : null;
                            const displayMarketValue = (
                              outcome,
                              source
                            ) => {
                              const value =
                                getLeagueDisplayedValue(
                                  row,
                                  outcome,
                                  source
                                );
                              return value;
                            };

                            const finishedOutcome =
                              leagueAnalysisView === "1x2"
                                ? getFinishedOutcome(row)
                                : null;

                            const finished =
                              finishedOutcome !== null;

                            return (
                              <Box
                                title="Doppelklick: Indikation im experimentellen Arbeitsbereich prüfen"
                                onDoubleClick={event => { event.stopPropagation(); setFixtureDetailsRow({...row, open_experimental_analysis:true}); }}
                                sx={{
                                  display: "grid",
                                  gridTemplateColumns:
                                    leagueAnalysisView === "1x2"
                                      ? leagueOddsDisplay === "odds"
                                        ? LEAGUE_1X2_ODDS_GRID_COLUMNS
                                        : LEAGUE_1X2_COMPARISON_GRID_COLUMNS
                                      : ["over-under", "asian-handicap"].includes(leagueAnalysisView)
                                        ? "72px repeat(3, minmax(0, 1fr))"
                                        : "repeat(3, minmax(0, 1fr))",
                                  gap: 0.5,
                                  justifyContent:
                                    leagueAnalysisView === "1x2"
                                      ? "start"
                                      : "stretch",
                                }}
                              >
                                {["over-under", "asian-handicap"].includes(leagueAnalysisView) && (
                                  <TextField
                                    select
                                    size="small"
                                    value={displayedLine || ""}
                                    onClick={(event) => event.stopPropagation()}
                                    onChange={(event) => {
                                      const line = normalizeGoalLine(event.target.value);
                                      if (!line) return;
                                      const setter = leagueAnalysisView === "over-under"
                                        ? setLeagueGoalLineOverrides
                                        : setLeagueHandicapLineOverrides;
                                      setter((current) => ({
                                          ...current,
                                          [String(row.id)]: line,
                                        }));
                                    }}
                                    SelectProps={{ native: true }}
                                    sx={{
                                      width: 72,
                                      "& .MuiInputBase-root": { height: 30, fontSize: "0.74rem" },
                                    }}
                                  >
                                    {!displayedLine && <option value="">–</option>}
                                    {(leagueAnalysisView === "over-under"
                                      ? getFixtureGoalLines(
                                          row,
                                          leagueMarketOdds[String(row.id)]
                                        )
                                      : getFixtureHandicapLines(
                                          row,
                                          leagueMarketOdds[String(row.id)]
                                        )
                                    ).map((line) => (
                                      <option key={line} value={line}>
                                        {leagueAnalysisView === "asian-handicap"
                                          ? formatAsianHandicapLine(line)
                                          : Number(line).toLocaleString("de-DE")}
                                      </option>
                                    ))}
                                  </TextField>
                                )}
                                <Box
                                  sx={{
                                    display: "grid",
                                    gridTemplateColumns:
                                      `repeat(${outcomes.length}, minmax(0, 1fr))`,
                                    gap: 0.25,
                                    px: 0.45,
                                    py: 0.22,
                                    borderLeft:
                                      "1px solid rgba(126, 53, 88, 0.30)",
                                    borderRight:
                                      "1px solid rgba(126, 53, 88, 0.30)",
                                    bgcolor:
                                      "rgba(126, 53, 88, 0.055)",
                                  }}
                                >
                                  {outcomes.map(
                                    (outcome) => {
                                      return (
                                        <Box
                                          key={outcome}
                                          sx={{
                                            minWidth: 0,
                                            py: 0.35,
                                            px: 0.1,
                                            textAlign:
                                              "center",
                                            border:
                                              "1px solid",
                                            borderColor:
                                              "transparent",
                                            bgcolor:
                                              "transparent",
                                            borderRadius: 0.5,
                                          }}
                                        >
                                          <Typography
                                            variant="body2"
                                            noWrap
                                            sx={{
                                              fontWeight:
                                                800,
                                              fontVariantNumeric:
                                                "tabular-nums",
                                              fontSize:
                                                leagueOddsDisplay === "odds"
                                                  ? "0.88rem"
                                                  : "0.82rem",
                                              letterSpacing:
                                                leagueOddsDisplay === "odds"
                                                  ? 0
                                                  : "-0.025em",
                                              lineHeight: 1.15,
                                            }}
                                          >
                                            {displayMarketValue(
                                              outcome,
                                              "betty"
                                            )}
                                          </Typography>
                                        </Box>
                                      );
                                    }
                                  )}
                                </Box>

                                <Box
                                  sx={{
                                    display: "grid",
                                    gridTemplateColumns:
                                      `repeat(${outcomes.length}, minmax(0, 1fr))`,
                                    gap: 0.25,
                                    px: 0.45,
                                    py: 0.22,
                                    borderLeft:
                                      "1px solid rgba(56, 149, 184, 0.30)",
                                    borderRight:
                                      "1px solid rgba(56, 149, 184, 0.30)",
                                    bgcolor:
                                      "rgba(56, 149, 184, 0.055)",
                                  }}
                                >
                                  {outcomes.map(
                                    (outcome) => {
                                      return (
                                        <Box
                                          key={outcome}
                                          sx={{
                                            minWidth: 0,
                                            py: 0.35,
                                            px: 0.1,
                                            textAlign:
                                              "center",
                                            border:
                                              "1px solid",
                                            borderColor:
                                              "transparent",
                                            bgcolor:
                                              "transparent",
                                            borderRadius: 0.5,
                                          }}
                                        >
                                          <Typography
                                            variant="body2"
                                            noWrap
                                            sx={{
                                              fontWeight:
                                                800,
                                              fontVariantNumeric:
                                                "tabular-nums",
                                              fontSize:
                                                leagueOddsDisplay === "odds"
                                                  ? "0.88rem"
                                                  : "0.82rem",
                                              letterSpacing:
                                                leagueOddsDisplay === "odds"
                                                  ? 0
                                                  : "-0.025em",
                                              lineHeight: 1.15,
                                            }}
                                          >
                                            {displayMarketValue(
                                              outcome,
                                              "statistic"
                                            )}
                                          </Typography>

                                </Box>
                                      );
                                    }
                                  )}
                                          {!leagueStatisticModels[String(row.id)] && <Typography variant="caption" sx={{gridColumn:"1 / -1",textAlign:"center",color:"text.secondary"}}>
                                    {leagueStatisticStatus === "loading" ? "…" : leagueStatisticStatus === "error"
                                      ? (i18next.language?.startsWith("de") ? "Abruf fehlgeschlagen" : "Read failed")
                                      : (i18next.language?.startsWith("de") ? "Nicht verfügbar" : "Not available")}
                                  </Typography>}
                                </Box>

                                <Box
                                  sx={{
                                    display: "grid",
                                    gridTemplateColumns:
                                      `repeat(${outcomes.length}, minmax(0, 1fr))`,
                                    gap: 0.25,
                                    px: 0.45,
                                    py: 0.22,
                                    borderLeft:
                                      "2px solid",
                                    borderRight:
                                      "1px solid",
                                    borderColor:
                                      "divider",
                                    bgcolor:
                                      "rgba(0, 0, 0, 0.025)",
                                  }}
                                >
                                  {outcomes.map(
                                    (outcome) => {
                                      const fairOdd =
                                        getLeagueBettyOdd(
                                          row,
                                          outcome
                                        );

                                      const marketOdd =
                                        getLeagueMarketOdd(
                                          row,
                                          outcome
                                        );

                                      const advantagePercent =
                                        Number.isFinite(
                                          fairOdd
                                        ) &&
                                        fairOdd > 0 &&
                                        Number.isFinite(
                                          marketOdd
                                        )
                                          ? (
                                              marketOdd /
                                                fairOdd -
                                              1
                                            ) * 100
                                          : null;

                                      const statisticFairOdd = storedModelOdd(leagueStatisticModels[String(row.id)], leagueAnalysisView, outcome,
                                        leagueAnalysisView === "over-under" ? getSelectedGoalLine(row) : getSelectedHandicapLine(row));
                                      const hasIndication =
                                        hasConsensusOddsIndication(
                                          fairOdd,
                                          statisticFairOdd,
                                          marketOdd,
                                          leagueIndicationThreshold
                                        );

                                      const won =
                                        leagueAnalysisPhase ===
                                          "post" &&
                                        finished &&
                                        finishedOutcome ===
                                          outcome;

                                      const indicationWon =
                                        leagueAnalysisPhase ===
                                          "post" &&
                                        finished &&
                                        hasIndication &&
                                        won;

                                      const indicationLost =
                                        leagueAnalysisPhase ===
                                          "post" &&
                                        finished &&
                                        hasIndication &&
                                        !won;

                                      let borderColor =
                                        "transparent";

                                      if (indicationWon) {
                                        borderColor =
                                          "success.main";
                                      } else if (
                                        indicationLost
                                      ) {
                                        borderColor =
                                          "error.main";
                                      } else if (won) {
                                        borderColor =
                                          "success.main";
                                      } else if (
                                        leagueAnalysisPhase ===
                                          "pre" &&
                                        hasIndication
                                      ) {
                                        borderColor =
                                          "primary.main";
                                      }

                                      return (
                                        <Box
                                          key={outcome}
                                          onDoubleClick={event => {
                                            event.stopPropagation();
                                            setFixtureDetailsRow({...row, analysisContext: {market: leagueAnalysisView, selection: outcome, line: leagueAnalysisView === "over-under" ? getSelectedGoalLine(row) : leagueAnalysisView === "asian-handicap" ? getSelectedHandicapLine(row) : null, basis: leagueMarketBasis, quote: marketOdd}});
                                          }}
                                          title={
                                            Number.isFinite(
                                              fairOdd
                                            ) &&
                                            Number.isFinite(
                                              marketOdd
                                            )
                                              ? [
                                                  (i18next.language?.startsWith("de") ? "Statistikmodell · faire Quote: " : "Statistics model · fair odds: ") + (statisticFairOdd?.toFixed(2) ?? "–"),
                                                  i18next.t(
                                                    "help.leagueAnalysis.fairOddsTooltip",
                                                    {
                                                      value:
                                                        fairOdd.toFixed(2),
                                                    }
                                                  ),
                                                  i18next.t(
                                                    "help.leagueAnalysis.marketOddsTooltip",
                                                    {
                                                      value:
                                                        marketOdd.toFixed(2),
                                                    }
                                                  ),
                                                  i18next.t(
                                                    "help.leagueAnalysis.advantageTooltip",
                                                    {
                                                      value:
                                                        advantagePercent.toFixed(1),
                                                    }
                                                  ),
                                                  i18next.t(
                                                    "help.leagueAnalysis.thresholdTooltip",
                                                    {
                                                      value:
                                                        Number(
                                                          leagueIndicationThreshold
                                                        ).toFixed(1),
                                                    }
                                                  ),
                                                  indicationWon
                                                    ? i18next.t(
                                                        "help.leagueAnalysis.indicationWon"
                                                      )
                                                    : indicationLost
                                                      ? i18next.t(
                                                          "help.leagueAnalysis.indicationLost"
                                                        )
                                                      : hasIndication
                                                        ? i18next.t(
                                                            "help.leagueAnalysis.bettyIndication"
                                                          )
                                                        : i18next.t(
                                                            "help.leagueAnalysis.belowThreshold"
                                                          ),
                                                ].join("\n")
                                              : won
                                                ? i18next.t(
                                                    "help.leagueAnalysis.occurredOutcome"
                                                  )
                                                : undefined
                                          }
                                          sx={{
                                            minWidth: 0,
                                            py: 0.35,
                                            px: 0.1,
                                            textAlign:
                                              "center",
                                            border:
                                              "1px solid",
                                            borderColor,
                                            bgcolor:
                                              indicationWon
                                                ? "rgba(46, 125, 50, 0.16)"
                                                : indicationLost
                                                  ? "rgba(211, 47, 47, 0.07)"
                                                  : won
                                                    ? "rgba(46, 125, 50, 0.08)"
                                                    : "transparent",
                                            borderRadius: 0.5,
                                          }}
                                        >
                                          <Typography
                                            variant="body2"
                                            noWrap
                                            color={
                                              indicationLost
                                                ? "error.main"
                                                : hasIndication
                                                  ? "primary.main"
                                                  : "text.primary"
                                            }
                                            sx={{
                                              fontWeight:
                                                won ||
                                                hasIndication
                                                  ? 900
                                                  : 800,
                                              fontVariantNumeric:
                                                "tabular-nums",
                                              fontSize:
                                                leagueOddsDisplay === "odds"
                                                  ? "0.88rem"
                                                  : "0.82rem",
                                              letterSpacing:
                                                leagueOddsDisplay === "odds"
                                                  ? 0
                                                  : "-0.025em",
                                              lineHeight: 1.15,
                                            }}
                                          >
                                            {indicationWon
                                              ? "✓ "
                                              : indicationLost
                                                ? "× "
                                                : ""}
                                            {displayMarketValue(
                                              outcome,
                                              "market"
                                            )}
                                          </Typography>
                                        </Box>
                                      );
                                    }
                                  )}
                                  {!outcomes.some(outcome => getLeagueMarketOdd(row, outcome) !== null) && <Typography variant="caption" sx={{gridColumn:"1 / -1",textAlign:"center",color:"text.secondary"}}>
                                    {leagueMarketLoading ? (i18next.language?.startsWith("de") ? "Lädt …" : "Loading …") : (i18next.language?.startsWith("de") ? "Keine passenden Pre-Match-Quoten verfügbar" : "No matching pre-match prices available")}
                                  </Typography>}
                                  {leagueMarketOdds[String(row.id)]?.prematch_context?.stale && <Typography variant="caption" sx={{gridColumn:"1 / -1",textAlign:"center"}}>
                                    {i18next.language?.startsWith("de") ? "Letzter verfügbarer Quotenstand" : "Last available prices"}: {leagueMarketOdds[String(row.id)].prematch_context.as_of}
                                  </Typography>}
                                </Box>

                                {leagueAnalysisView === "1x2" &&
                                leagueOddsDisplay !== "odds" && <Box
                                  sx={{
                                    minWidth: 0,
                                    py: 0.57,
                                    px: 0.2,
                                    textAlign:
                                      "center",
                                    bgcolor:
                                      "rgba(0, 0, 0, 0.025)",
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    noWrap
                                    sx={{
                                      fontWeight: 900,
                                      fontVariantNumeric:
                                        "tabular-nums",
                                      lineHeight: 1.15,
                                    }}
                                  >
                                    {getLeagueSummaryValue(
                                      row
                                    )}
                                  </Typography>
                                </Box>}
                              </Box>
                            );
                          })()
                        ) : (
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                              pl: 0.5,
                            }}
                          >
                            –
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  );
                }
              )}

            {!leagueLoading &&
              !leagueError &&
              !leagueRows.length && (
                <Typography
                  sx={{
                    p: 2,
                  }}
                  color="text.secondary"
                >
                  Für diesen Spieltag wurden keine Spiele gefunden.
                </Typography>
              )}

            {!leagueLoading &&
              !leagueError &&
              showPerfectTipsMarket &&
              leagueRows.length > 0 && (
                <PerfectTipsSummary
                  summary={summarizePerfectTipsGames(
                    leagueRows.map(getPerfectTipsResult)
                  )}
                />
              )}

            {!leagueLoading &&
              !leagueError &&
              showLeaguePostMatchComparison &&
              leagueRows.length > 0 && (
                <LeagueMatchdayComparison
                  fixtures={leagueRows}
                />
              )}
          </Paper>


  </>);
  const leagueFixtureWorkspace = (<>
          {selectedLeagueFixture && <Button onClick={()=>setTeamAnalysisFixture(selectedLeagueFixture)}>{i18next.language.startsWith("en")?"Team settings & analysis":"Team Settings & Analyse"}</Button>}
          {selectedLeagueFixture && (
            <Paper
              variant="outlined"
              sx={{
                overflow:
                  "hidden",
              }}
            >
              <Box
                sx={{
                  px: 1.5,
                  py: 0.75,
                  borderBottom:
                    "1px solid",
                  borderColor:
                    "divider",
                  bgcolor:
                    "action.hover",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 800,
                  }}
                >
                  {selectedLeagueFixture
                    ?.localTeam
                    ?.custom_name ||
                    selectedLeagueFixture
                      ?.localTeam
                      ?.name}
                  {" – "}
                  {selectedLeagueFixture
                    ?.visitorTeam
                    ?.custom_name ||
                    selectedLeagueFixture
                      ?.visitorTeam
                      ?.name}
                </Typography>
              </Box>

              <FixtureDetails
                row={
                  selectedLeagueFixture
                }
                handleRecompile={
                  handleRecompile
                }
                onDraftReset={resetLocalFixtureDraft}
                user={user}
                compactWorkspace
                strengthRanking={leagueStrengthRanking}
                strengthsRevision={effectiveTeamStrengthsRevision}
                actualRows={leagueSeasonBase?.actual_table || []}
                expectedRows={leagueSeasonComparison?.record?.expected_table || []}
                shouldRows={leagueSeasonComparison?.record?.should_table || []}
                expectedLedger={leagueSeasonComparison?.record?.expected?.ledger || []}
                shouldLedger={leagueSeasonComparison?.record?.should?.ledger || []}
                marketOdds={{
                  "1": getLeagueMarketOdd(selectedLeagueFixture, "1"),
                  X: getLeagueMarketOdd(selectedLeagueFixture, "X"),
                  "2": getLeagueMarketOdd(selectedLeagueFixture, "2"),
                }}
                indicationThreshold={leagueIndicationThreshold}
                onStrengthsSaved={async () => {
                  setLocalTeamStrengthsRevision((current) => current + 1);
                  await refreshLeagueStrengthRanking(
                    leagueSeasonFixtures,
                    selectedLeagueFixture?.stage_id
                  );
                }}
              />
            </Paper>
          )}
  </>);

  return (
    <ThemeProvider theme={workareaTheme}>{teamAnalysisFixture&&(canUseTeamWorkspace(user)?<TeamLeagueWorkspace user={user} leagues={leagues} initialLeague={{id:teamAnalysisFixture.league_id,name:teamAnalysisFixture.league?.name||leagues.find(l=>Number(l.id)===Number(teamAnalysisFixture.league_id))?.name||""}} initialSeason={teamAnalysisFixture.season_id} initialTeams={[Number(teamAnalysisFixture.localTeam?.id??teamAnalysisFixture.home_team_id),Number(teamAnalysisFixture.visitorTeam?.id??teamAnalysisFixture.away_team_id)]} fixture={teamAnalysisFixture} onClose={()=>setTeamAnalysisFixture(null)}/>:<TeamAnalysisDialog league={{id:teamAnalysisFixture.league_id,name:teamAnalysisFixture.league?.name||leagues.find(l=>Number(l.id)===Number(teamAnalysisFixture.league_id))?.name||""}} seasonId={teamAnalysisFixture.season_id} teamIds={[Number(teamAnalysisFixture.localTeam?.id??teamAnalysisFixture.home_team_id),Number(teamAnalysisFixture.visitorTeam?.id??teamAnalysisFixture.away_team_id)]} fixture={teamAnalysisFixture} indicationThreshold={leagueIndicationThreshold} onClose={()=>setTeamAnalysisFixture(null)}/>)}<Container maxWidth="xl" sx={{ height: "100%", bgcolor: "background.default", color: "text.primary", py: 2, borderRadius: 2 }}>
      <CompilePreviewDialog
        open={compilePreview.open}
        fixtureCount={compilePreview.fixtureIds.length}
        multiCompile={compilePreview.scope === "day" && compilePreview.fixtureIds.length > 1}
        calculationMethod={compilePreview.calculationMethod}
        preview={compilePreview.fixtures}
        teams={compilePreview.teams?.length ? compilePreview.teams : compilePreview.scope === "league" ? leagueStrengthRanking : undefined}
        loading={compilePreview.loading}
        running={compilePreview.running}
        error={compilePreview.error}
        success={compilePreview.success}
        missingSeasons={compilePreview.missingSeasons}
        onCancel={() => {
          if (!compilePreview.running) {
            setCompilePreview((current) => ({ ...current, open: false }));
          }
        }}
        onReviewSettings={compilePreview.scope === "league" ? () => {
          setCompilePreview((current) => ({ ...current, open: false }));
          setReviewLeagueSettings({
            ...selectedLeague,
            current_season_id: leagueSeason?.id ?? selectedLeague?.current_season_id,
          });
        } : undefined}
        onCalculationMethodChange={(calculationMethod) => {
          setCompilePreview((current) => ({ ...current, calculationMethod }));
        }}
        onConfirm={confirmCompilePreview}
      />
      <Dialog open={Boolean(fixtureDetailsRow)} onClose={() => setFixtureDetailsRow(null)} fullWidth maxWidth="xl">
        <DialogTitle sx={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:2}}>
          {i18next.language.startsWith("en") ? "Match details" : "Details zum Spiel"}
          <Button onClick={() => setFixtureDetailsRow(null)}>{i18next.language.startsWith("en") ? "Close" : "Schließen"}</Button>
        </DialogTitle>
        <DialogContent dividers>
          {fixtureDetailsRow && getDetailPanelContent({directAnalysis: true, row: {...([...leagueRows, ...rows].find(row => Number(row.id) === Number(fixtureDetailsRow.id)) || fixtureDetailsRow), analysisContext: fixtureDetailsRow.analysisContext}})}
        </DialogContent>
      </Dialog>
      <MyDataUpdateDialog
        targets={dataUpdateTargets(myDataUpdate.scope || "global")}
        onCompleted={() => refreshCompiledFixtureDetails([...rows, ...leagueRows].map(row => Number(row.id)))}
        state={myDataUpdate}
        isAdmin={getUserAccessLevel(user) === "admin"}
        onClose={() => setMyDataUpdate((current) => ({ ...current, open: false }))}
        onCheck={() => previewMyDataUpdate("global")}
        onStart={applyMyDataUpdate}
        onRequestFoundations={() => setMyDataUpdate((current) => ({ ...current, foundationConfirmation: true }))}
        onCancelFoundations={() => setMyDataUpdate((current) => ({ ...current, foundationConfirmation: false }))}
        onConfirmFoundations={applyMyDataFoundations}
        onCancel={cancelMyDataUpdate}
        onDecisionChange={(evaluateHistorical) => setMyDataUpdate((current) => ({ ...current, evaluateHistorical }))}
      />
      <Backdrop
        open={evaluationRunning}
        data-testid="evaluation-progress-lock"
        sx={{ zIndex: (theme) => theme.zIndex.modal + 2, bgcolor: "rgba(20, 15, 18, 0.58)", p: 2 }}
      >
        <Paper sx={{ width: "min(560px, 100%)", p: 3, boxShadow: 12 }} role="status" aria-live="polite">
          <Typography variant="h6" sx={{ fontWeight: 900 }}>
            {i18next.t("help.evaluationResult.runningWait")}
          </Typography>
          <Typography variant="body1" sx={{ mt: 0.75, mb: 2 }}>
            {i18next.t("help.evaluationResult.processedProgress", {
              current: evaluateProgress?.current || 0,
              total: evaluateProgress?.total || 0,
            })}
          </Typography>
          {evaluateProgress?.inFlight > 0 && <Typography sx={{mb:1.5}}>
            {i18next.t("help.dayWorkflow.processingBlock",{block:evaluateProgress.block,blocks:evaluateProgress.blocks,count:evaluateProgress.inFlight})}
          </Typography>}
          <LinearProgress
            variant="determinate"
            value={evaluateProgress?.total
              ? Math.min(100, ((evaluateProgress?.current || 0) / evaluateProgress.total) * 100)
              : 0}
            sx={{ height: 9, borderRadius: 5 }}
          />
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
            {i18next.t("help.evaluationResult.navigationLocked")}
          </Typography>
        </Paper>
      </Backdrop>
      <TeamStrengthDialog
        league={reviewLeagueSettings}
        setOpen={async (value) => {
          setReviewLeagueSettings(value || null);
          if (!value) {
            setLocalTeamStrengthsRevision((current) => current + 1);
            await refreshLeagueStrengthRanking(leagueSeasonFixtures, selectedLeagueFixture?.stage_id);
            if (compilePreview.fixtureIds.length) {
              await openCompilePreview(
                compilePreview.fixtureIds,
                "league",
                compilePreview.calculationMethod,
              );
            }
          }
        }}
        user={user}
      />
      {modalText !== "" ? (
        <Modal
          open={showModal}
          onClose={
            missingCompetitions.length ? handleCompileCancel : handleClose
          }
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              ...style,
              bgcolor: "background.paper", color:"text.primary",
              ...(evaluationResult &&
              evaluationResult?.success !== false
                ? {
                    width: "min(680px, calc(100vw - 32px))",
                    maxHeight: "calc(100vh - 48px)",
                    overflowY: "auto",
                    p: 2.5,
                  }
                : {}),
            }}
          >
            <Typography id="modal-modal-title" variant="h6" component="h2">
              {modalTitle}
            </Typography>

            {evaluationResult &&
            evaluationResult?.success !== false ? (
              <Box
                id="modal-modal-description"
                sx={{
                  mt: 1.25,
                  display: "grid",
                  gap: 1.25,
                }}
              >
                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 800,
                      color: "success.main",
                    }}
                  >
                    {evaluationResult.processed === 1
                      ? i18next.t(
                          "help.evaluationResult.successSingular"
                        )
                      : i18next.t(
                          "help.evaluationResult.successPlural",
                          {
                            count:
                              evaluationResult.processed,
                          }
                        )}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mt: 0.5 }}
                  >
                    {i18next.t(
                      "help.evaluationResult.successInfo"
                    )}
                  </Typography>
                </Box>

                {(evaluationResult.expectedUpdated > 0 ||
                  evaluationResult.shouldUpdated > 0) && (
                  <Box>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 800 }}
                    >
                      {i18next.t(
                        "help.evaluationResult.updatedTables"
                      )}
                    </Typography>

                    {evaluationResult.expectedUpdated > 0 && (
                      <Typography variant="body2">
                        <HelpTerm termKey="expectedTable">
                          Expected Table
                        </HelpTerm>
                        :{" "}
                        {evaluationResult.expectedUpdated}{" "}
                        {evaluationResult.expectedUpdated === 1
                          ? i18next.t(
                              "help.evaluationResult.updateSingular"
                            )
                          : i18next.t(
                              "help.evaluationResult.updatePlural"
                            )}
                      </Typography>
                    )}

                    {evaluationResult.shouldUpdated > 0 && (
                      <Typography variant="body2">
                        <HelpTerm termKey="shouldTable">
                          Should Table
                        </HelpTerm>
                        :{" "}
                        {evaluationResult.shouldUpdated}{" "}
                        {evaluationResult.shouldUpdated === 1
                          ? i18next.t(
                              "help.evaluationResult.updateSingular"
                            )
                          : i18next.t(
                              "help.evaluationResult.updatePlural"
                            )}
                      </Typography>
                    )}
                  </Box>
                )}

                {(evaluationResult.missingExpectedTables.length > 0 ||
                  evaluationResult.missingShouldTables.length > 0) && (
                  <Paper
                    variant="outlined"
                    sx={{ p: 1.25 }}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 800 }}
                    >
                      {i18next.t(
                        "help.evaluationResult.missingTables"
                      )}
                    </Typography>

                    {evaluationResult
                      .missingExpectedTables
                      .length > 0 && (
                      <Typography
                        variant="body2"
                        sx={{ mt: 0.5 }}
                      >
                        Expected Tables:{" "}
                        {evaluationResult
                          .missingExpectedTables
                          .map(
                            (item) =>
                              item.league_name ||
                              getEvaluationCompetitionName(
                                item.league_id,
                                item.season_id
                              )
                          )
                          .join(", ")}
                      </Typography>
                    )}

                    {evaluationResult
                      .missingShouldTables
                      .length > 0 && (
                      <Typography
                        variant="body2"
                        sx={{ mt: 0.25 }}
                      >
                        Should Tables:{" "}
                        {evaluationResult
                          .missingShouldTables
                          .map(
                            (item) =>
                              item.league_name ||
                              getEvaluationCompetitionName(
                                item.league_id,
                                item.season_id
                              )
                          )
                          .join(", ")}
                      </Typography>
                    )}

                    {(
                      !missingTablesActionResult ||
                      missingTablesActionResult.errors.length > 0
                    ) && (
                      <Button
                        variant="contained"
                        onClick={
                          handleCreateMissingEvaluationTables
                        }
                        disabled={creatingMissingTables}
                        sx={{
                          mt: 1,
                          textTransform: "none",
                        }}
                      >
                        {creatingMissingTables
                          ? i18next.t(
                              "help.evaluationResult.creatingMissingTables"
                            )
                          : i18next.t(
                              "help.evaluationResult.createMissingTables"
                            )}
                      </Button>
                    )}

                    {creatingMissingTables && (
                      <LinearProgress sx={{ mt: 1 }} />
                    )}

                    {missingTablesActionResult &&
                      missingTablesActionResult.errors.length === 0 &&
                      missingTablesActionResult.unavailable.length > 0 && (
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ mt: 1 }}
                        >
                          {i18next.t(
                            "help.evaluationResult.shouldUnavailableInfo"
                          )}
                        </Typography>
                      )}
                  </Paper>
                )}

                {missingTablesActionResult && (
                  <Paper
                    variant="outlined"
                    sx={{ p: 1.25 }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 800 }}
                    >
                      {i18next.t(
                        "help.evaluationResult.createdSummary",
                        {
                          expected:
                            missingTablesActionResult.expectedCreated,
                          should:
                            missingTablesActionResult.shouldCreated,
                        }
                      )}
                    </Typography>

                    {missingTablesActionResult
                      .unavailable
                      .map((item, index) => (
                        <Typography
                          key={`table-unavailable-${index}`}
                          variant="caption"
                          display="block"
                          color="text.secondary"
                        >
                          {item.league_name} ·{" "}
                          {item.table}:{" "}
                          {item.message}
                        </Typography>
                      ))}

                    {missingTablesActionResult
                      .errors
                      .map((item, index) => (
                        <Typography
                          key={`table-error-${index}`}
                          variant="caption"
                          display="block"
                          color="error.main"
                        >
                          {item.league_name} ·{" "}
                          {item.table}:{" "}
                          {item.message}
                        </Typography>
                      ))}
                  </Paper>
                )}

                {missingTablesActionResult &&
                  missingTablesActionResult.errors.length === 0 &&
                  evaluationResult.missingExpectedTables.length === 0 && (
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 1.5,
                        borderColor: "success.main",
                        bgcolor: "rgba(46, 125, 50, 0.08)",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        sx={{
                          color: "success.main",
                          fontWeight: 800,
                        }}
                      >
                        {i18next.t(
                          "help.evaluationResult.expectedCompleteTitle"
                        )}
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{ mt: 0.5 }}
                      >
                        {i18next.t(
                          "help.evaluationResult.expectedCompleteInfo"
                        )}
                      </Typography>

                      <Typography
                        variant="subtitle2"
                        sx={{
                          mt: 1,
                          color: "success.main",
                          fontWeight: 800,
                        }}
                      >
                        {i18next.t(
                          "help.evaluationResult.shouldProcessedTitle"
                        )}
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{ mt: 0.5 }}
                      >
                        {i18next.t(
                          "help.evaluationResult.shouldProcessedInfo"
                        )}
                        {evaluationResult.missingShouldTables.length > 0
                          ? ` ${i18next.t(
                              "help.evaluationResult.shouldStillUnavailable",
                              {
                                count:
                                  evaluationResult.missingShouldTables.length,
                              }
                            )}`
                          : ""}
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          mt: 1,
                          color: "success.main",
                          fontWeight: 800,
                        }}
                      >
                        {i18next.t(
                          "help.evaluationResult.allClear"
                        )}
                      </Typography>
                    </Paper>
                  )}

                <Button
                  variant="text"
                  onClick={() =>
                    setShowEvaluationDetails(
                      (current) => !current
                    )
                  }
                  sx={{
                    justifySelf: "start",
                    px: 0,
                    textTransform: "none",
                  }}
                >
                  {showEvaluationDetails
                    ? i18next.t(
                        "help.evaluationResult.hideDetails"
                      )
                    : i18next.t(
                        "help.evaluationResult.showDetails"
                      )}
                </Button>

                {showEvaluationDetails && (
                  <Paper
                    variant="outlined"
                    sx={{ p: 1.5 }}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 800, mb: 1 }}
                    >
                      {i18next.t(
                        "help.evaluationResult.detailsTitle"
                      )}
                    </Typography>

                    <Typography variant="body2">
                      {i18next.t(
                        "help.evaluationResult.evaluatedFixtures"
                      )}:{" "}
                      {evaluationResult.processed}
                    </Typography>

                    <Typography variant="body2">
                      {i18next.t(
                        "help.evaluationResult.expectedUpdates"
                      )}:{" "}
                      {evaluationResult.expectedUpdated}
                    </Typography>

                    <Typography variant="body2">
                      {i18next.t(
                        "help.evaluationResult.shouldUpdates"
                      )}:{" "}
                      {evaluationResult.shouldUpdated}
                    </Typography>

                    <Typography variant="body2">
                      {i18next.t(
                "help.evaluationResult.fixtures"
              )} mit vollständigen{" "}
                      <HelpTerm termKey="matchStatistics">
                        Match Statistics
                      </HelpTerm>
                      :{" "}
                      {evaluationResult.shouldStatisticsComplete}
                    </Typography>

                    <Typography variant="body2">
                      Fixtures mit unvollständigen{" "}
                      <HelpTerm termKey="matchStatistics">
                        Match Statistics
                      </HelpTerm>
                      :{" "}
                      {evaluationResult.shouldStatisticsIncomplete}
                    </Typography>

                    <Typography variant="body2">
                      {i18next.t(
                        "help.evaluationResult.auxiliaryErrors"
                      )}:{" "}
                      {evaluationResult.auxiliaryErrors}
                    </Typography>

                  </Paper>
                )}

                <Button
                  variant="outlined"
                  onClick={handleClose}
                  sx={{
                    justifySelf: "end",
                  }}
                >
                  {i18next.t(
                    "help.evaluationResult.done"
                  )}
                </Button>
              </Box>
            ) : (
              <Typography
                id="modal-modal-description"
                sx={{ mt: 2 }}
              >
                {modalText}
              </Typography>
            )}

            {missingCompetitions.length > 0 && (
              <>
                <Box
                  component="ul"
                  sx={{
                    mt: 2,
                    mb: 2,
                    pl: 3,
                  }}
                >
                  {missingCompetitions.map((competition) => (
                    <li key={competition.season_id}>
                      <Typography>{competition.league_name}</Typography>
                    </li>
                  ))}
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    mt: 2,
                  }}
                >
                  <Button variant="contained" onClick={handleTakeFromWettopa}>
                    Wettopa-Settings übernehmen und kompilieren
                  </Button>

                  <Button variant="outlined" onClick={handleCompileAvailable}>
                    Ohne diese Wettbewerbe fortfahren
                  </Button>

                  <Button variant="text" onClick={handleCompileCancel}>
                    Abbrechen
                  </Button>
                </Box>
              </>
            )}
          </Box>
        </Modal>
      ) : (
        ""
      )}

      <Paper
        variant="outlined"
        sx={{
          mb: 1.5,
          px: 1,
          py: 0.75,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        {onLeagueSelection && <Button onClick={onLeagueSelection} disabled={evaluationRunning || leagueSettingsDirty}>{i18next.t("help.start.games")}</Button>}
        <ToggleButtonGroup
          exclusive
          size="small"
          value={workspaceMode}
          onChange={(
            event,
            value
          ) => {
            if (!value) {
              return;
            }

            setWorkspaceMode(value);

            sessionStorage.setItem(
              "fixturesWorkspaceMode",
              value
            );
          }}
        >
          <ToggleButton
            value="day"
            disabled={evaluationRunning || leagueSettingsDirty}
            sx={{
              px: 2,
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            {i18next.t("help.start.day")}
          </ToggleButton>

          <ToggleButton value="week" disabled={evaluationRunning || leagueSettingsDirty} sx={{px:2,textTransform:"none",fontWeight:700}}>{i18next.t("help.navigation.week")}</ToggleButton>
          <ToggleButton
            value="league"
            disabled={evaluationRunning || leagueSettingsDirty}
            sx={{
              px: 2,
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            {i18next.t("help.start.leagueChoice")}
          </ToggleButton>
        </ToggleButtonGroup>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            ml: 1,
          }}
        >
          {workspaceMode === "day"
            ? i18next.t("help.navigation.dayCount",{count:rows.length,date:startDate.toLocaleDateString()})
            : workspaceMode === "week" ? i18next.t("help.navigation.weekCount",{count:rows.length}) : i18next.t("help.navigation.leagueHint")}
        </Typography>
      </Paper>


      {["day","week"].includes(workspaceMode) && <GamesRangeControls onRefresh={() => refreshFixturesRef.current?.()} refreshing={fixturesRefreshing} lastUpdated={fixturesUpdatedAt} refreshError={fixturesRefreshError} statistics={<DayStatisticsEntry rows={rows} day={workspaceMode === "week" ? weekRange.start : startDate} endDay={workspaceMode === "week" ? weekRange.end : undefined} user={user}/>} mode={workspaceMode} day={startDate} onDay={setStartDate} range={weekRange} onRange={setWeekRange} disabled={evaluationRunning || leagueSettingsDirty}/>}

      {evaluateProgress && (
        <Paper
          sx={{
            mb: 2,
            p: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent:
                "space-between",
              alignItems:
                "center",
              gap: 2,
              mb: 1,
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
              }}
            >
              {i18next.t(
                "help.evaluationResult.running"
              )}
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
            >
              {
                evaluateProgress.current
              }{" "}
              /{" "}
              {
                evaluateProgress.total
              }{" "}
              Fixtures
            </Typography>
          </Box>

          <LinearProgress
            variant="determinate"
            value={
              evaluateProgress.total
                ? Math.min(
                    100,
                    (
                      evaluateProgress.current /
                      evaluateProgress.total
                    ) * 100,
                  )
                : 0
            }
          />

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              mt: 1.5,
            }}
          >
            <Typography
              variant="body2"
            >
              {i18next.t(
                "help.evaluationResult.expectedUpdatesShort"
              )}:{" "}
              {
                evaluateProgress
                  .expectedUpdated
              }
            </Typography>

            <Typography
              variant="body2"
            >
              {i18next.t(
                "help.evaluationResult.shouldUpdatesShort"
              )}:{" "}
              {
                evaluateProgress
                  .shouldUpdated
              }
            </Typography>

            <Typography
              variant="body2"
            >
              {i18next.t(
                "help.evaluationResult.statisticsComplete"
              )}:{" "}
              {
                evaluateProgress
                  .shouldStatisticsComplete
              }
            </Typography>

            {evaluateProgress
              .shouldStatisticsIncomplete >
              0 && (
              <Typography
                variant="body2"
              >
                {i18next.t(
                  "help.evaluationResult.statisticsIncomplete"
                )}:{" "}
                {
                  evaluateProgress
                    .shouldStatisticsIncomplete
                }
              </Typography>
            )}
          </Box>

        </Paper>
      )}

      {workspaceMode === "league" && (
        <LeagueMatchdayEntry user={user} disabled={evaluationRunning || leagueSettingsDirty}>
          {isTest => isTest ? (
            <AdminLeagueWorkspace user={user} league={selectedLeague} season={leagueSeason} seasons={leagueSeasons}
              round={leagueRound} rounds={leagueRounds} fixtures={leagueSeasonFixtures} rows={leagueRows.map(row => ({...row, statistic_prediction:leagueStatisticModels[String(row.id)]}))}
              comparison={leagueSeasonComparison} base={leagueSeasonBase} teams={leagueStrengthRanking}
              onRefreshResults={refreshAdminLeagueResults}
              controls={renderLeagueHeader(true)} pairings={leaguePairings} fixtureWorkspace={leagueFixtureWorkspace}
              selectedFixture={selectedLeagueFixture} onSelect={setSelectedLeagueFixtureId}
              dirty={leagueSettingsDirty} onDirtyChange={setLeagueSettingsDirty}
              onRoundChange={(round, fixtureId) => { pendingAdminFixture.current = fixtureId; setRequestedLeagueRoundId(round.id); }}
              onSaved={async () => {
                setLocalTeamStrengthsRevision(current => current + 1);
                await refreshLeagueStrengthRanking(leagueSeasonFixtures, leagueRows[0]?.stage_id);
                setLeagueSeasonComparison(await fetchLeagueSeasonComparison(selectedLeague.id, leagueSeason.id));
              }}
            />
          ) : <Box sx={{ display: "grid", gap: 1.5 }}>{renderLeagueHeader(false)}{leaguePairings}{leagueFixtureWorkspace}</Box>}
        </LeagueMatchdayEntry>
      )}

      {["day","week"].includes(workspaceMode) && (
      <Box
        sx={{
          display: "flex",
          height: "75vh",
          "& .model-odds-header .MuiDataGrid-columnHeaderTitleContainerContent": {width:"100%"},
          "& .league-group-start": {borderTop:"3px solid #7694a5"},
          "& .row--expanded": {
            bgcolor: (theme) => "rgb(255,181,99,0.2)",
          },
        }}
        component={Paper}
      >
        <div style={{ flexGrow: 1 }}>
          {!!rows?.length && (
            <DataGridPro
              onRowDoubleClick={({row})=>setFixtureDetailsRow(row)}
              onDetailPanelExpandedRowIdsChange={
                handleDetailPanelExpandedRowIdsChange
              }
              getRowClassName={(params) =>
                `${workspaceMode === "week" && groupStarts.has(params.row.id) ? "league-group-start " : ""}row--${
                  detailPanelExpandedRowIds.includes(params.row.id)
                    ? "expanded"
                    : "collapsed"
                }`
              }
              getDetailPanelHeight={() => "auto"}
              getDetailPanelContent={getDetailPanelContent}
              onSelectionModelChange={(newSelectionModel) => {
                setSelectionModel(workspaceMode === "week" ? newSelectionModel.filter(id => weekEligibleIds.includes(id)) : newSelectionModel);
              }}
              selectionModel={activeSelection}
              checkboxSelection
              onKeyDown={event=>{
                if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase()==='a' && !['INPUT','TEXTAREA'].includes(event.target.tagName)) {
                  event.preventDefault(); event.defaultMuiPrevented=true;
                  setSelectionModel(selectVisibleEligible());
                }
              }}
              disableSelectionOnClick
              isRowSelectable={({row})=>selectableDayFixture(row,mode,forceCompile)}
              components={{
                Toolbar: () => (
                  <FixturesToolbar
                    weekView={workspaceMode === "week"}
                    onSelectAll={() => setSelectionModel(weekCompilationSelection(rows, forceCompile))}
                    onSelectUncompiled={() => setSelectionModel(weekCompilationSelection(rows, forceCompile, true))}
                    mode={mode}
                    handleModeChange={handleModeChange}
                    selectionModel={activeSelection}
                    handleCompileConfirm={handleCompileConfirm}
                    handleEvaluateConfirm={handleEvaluateConfirm}
                    forceCompile={forceCompile}
                    setSelectionModel={setSelectionModel}
                    setForceCompile={setForceCompile}
                  />
                ),
                Footer: () => (
                  <FixturesFooter
                    selectionModel={activeSelection}
                    mode={mode}
                    handleCompileConfirm={handleCompileConfirm}
                    handleEvaluateConfirm={handleEvaluateConfirm}
                  />
                ),
              }}
              rows={displayRows.map(row => ({...row, show_fixture_date:workspaceMode === "week", statistic_prediction: leagueStatisticModels[String(row.id)], statistic_read_status: statisticReadErrors[`${row.league_id}:${row.season_id}`] ? "error" : leagueStatisticStatus}))}
              columns={[{field:"fixture_details",headerName:i18next.language.startsWith("en")?"Details":"Details",width:70,sortable:false,renderCell:({row})=>fixtureDetailsButton(row)},{field:"team_analysis",headerName:i18next.language.startsWith("en")?"Analysis":"Analyse",width:155,sortable:false,renderCell:({row})=><Button onClick={()=>setTeamAnalysisFixture(row)}>{i18next.language.startsWith("en")?"Settings & analysis":"Settings & Analyse"}</Button>},{
                ...GRID_CHECKBOX_SELECTION_COL_DEF,
                renderHeader: () => {
                  const relevant=selectVisibleEligible();
                  return <Checkbox inputProps={{"aria-label":i18next.t("help.dayWorkflow.selectRelevant")}}
                    checked={relevant.length>0 && relevant.every(id=>activeSelection.includes(id))}
                    indeterminate={activeSelection.length>0 && !relevant.every(id=>activeSelection.includes(id))}
                    onChange={(_,checked)=>setSelectionModel(checked?relevant:[])}/>;
                },
              }, ...fixtureColumns.filter(column => !["homewin","draw","awaywin"].includes(column.field)).map(column => column.field === "agl" && workspaceMode === "week" ? {...column, renderCell: ({row}) => <AsianHandicapMenu row={row} weekView />} : column.field === "league" ? {
                ...column,
                renderCell: ({row}) => <Button size="small" onClick={() => {
                  const league = leagues.find(item => Number(item.id) === Number(row.league_id));
                  if (!league) return;
                  setSelectedLeague(league);
                  setRequestedLeagueSeasonId(row.season_id);
                  setRequestedLeagueRoundId(row.round_id);
                  setWorkspaceMode("league");
                }}>{fixtureColumns.find(c => c.field === "league").renderCell({value:row.league})}</Button>,
              } : column)].map(column=>({...column,sortable:false}))}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={(newModel) => {
                setColumnVisibilityModel(newModel);
              }}
            />
          )}
        </div>
      </Box>
      )}
    </Container></ThemeProvider>
  );

  function toggleStats() {
    if (showStats === "hidden") return setShowStats("visible");
    else return setShowStats("hidden");
  }
}
